// This file is autogenerated by tools/genMaterialLibrary. DO NOT EDIT IT DIRECTLY.
export const MasonryNameById = [
  "TrimColorCodes",
  "Brick_03_L_Cherokee_Augusta",
  "Brick_03_L_Cherokee_Natchez",
  "Brick_03_L_FAKE_Chalk",
  "Brick_03_L_Meridian_Alamo",
  "Brick_03_L_Meridian_AlpineSelect",
  "Brick_03_L_Meridian_Baytown",
  "Brick_03_L_Meridian_Belhaven",
  "Brick_03_L_Meridian_Dover",
  "Brick_03_L_Meridian_Laredo",
  "Brick_03_L_Meridian_MtRushmore",
  "Brick_03_L_Meridian_NorthHighland",
  "Brick_03_L_Meridian_OldGuignard",
  "Brick_03_L_Meridian_OldJackson",
  "Brick_03_L_Meridian_SaltPlains",
  "Brick_03_L_Meridian_ShadowFalls",
  "Brick_03_L_Meridian_Smithsonian",
  "Brick_03_L_Meridian_StAndrews",
  "Brick_03_L_Meridian_StLorain",
  "Brick_03_L_Meridian_SummerAsh",
  "Brick_03_L_Paint_SW_SW_7068_GrizzleGray",
  "Brick_03_L_Triangle_BessemerGray",
  "Brick_03_L_Triangle_EvelynBay",
  "Brick_03_L_Triangle_MountainBranchSelect",
  "Brick_03_L_Triangle_Oxford",
  "Brick_03_L_Triangle_SouthHampton",
  "Brick_05_L_Cherokee_Augusta",
  "Brick_05_L_Cherokee_Natchez",
  "Brick_05_L_FAKE_Chalk",
  "Brick_05_L_Meridian_Alamo",
  "Brick_05_L_Meridian_AlpineSelect",
  "Brick_05_L_Meridian_Baytown",
  "Brick_05_L_Meridian_Belhaven",
  "Brick_05_L_Meridian_Dover",
  "Brick_05_L_Meridian_Laredo",
  "Brick_05_L_Meridian_MtRushmore",
  "Brick_05_L_Meridian_NorthHighland",
  "Brick_05_L_Meridian_OldGuignard",
  "Brick_05_L_Meridian_OldJackson",
  "Brick_05_L_Meridian_SaltPlains",
  "Brick_05_L_Meridian_ShadowFalls",
  "Brick_05_L_Meridian_Smithsonian",
  "Brick_05_L_Meridian_StAndrews",
  "Brick_05_L_Meridian_StLorain",
  "Brick_05_L_Meridian_SummerAsh",
  "Brick_05_L_Paint_SW_SW_7068_GrizzleGray",
  "Brick_05_L_Triangle_BessemerGray",
  "Brick_05_L_Triangle_EvelynBay",
  "Brick_05_L_Triangle_MountainBranchSelect",
  "Brick_05_L_Triangle_Oxford",
  "Brick_05_L_Triangle_SouthHampton",
  "Brick_075_Default",
  "Brick_Bracciano_Default",
  "BrickKing_L_Cherokee_Augusta",
  "BrickKing_L_Cherokee_Natchez",
  "BrickKing_L_FAKE_Chalk",
  "BrickKing_L_Meridian_Alamo",
  "BrickKing_L_Meridian_AlpineSelect",
  "BrickKing_L_Meridian_Baytown",
  "BrickKing_L_Meridian_Belhaven",
  "BrickKing_L_Meridian_Dover",
  "BrickKing_L_Meridian_Laredo",
  "BrickKing_L_Meridian_MtRushmore",
  "BrickKing_L_Meridian_NorthHighland",
  "BrickKing_L_Meridian_OldGuignard",
  "BrickKing_L_Meridian_OldJackson",
  "BrickKing_L_Meridian_SaltPlains",
  "BrickKing_L_Meridian_ShadowFalls",
  "BrickKing_L_Meridian_Smithsonian",
  "BrickKing_L_Meridian_StAndrews",
  "BrickKing_L_Meridian_StLorain",
  "BrickKing_L_Meridian_SummerAsh",
  "BrickKing_L_Paint_SW_SW_7068_GrizzleGray",
  "BrickKing_L_Triangle_BessemerGray",
  "BrickKing_L_Triangle_EvelynBay",
  "BrickKing_L_Triangle_MountainBranchSelect",
  "BrickKing_L_Triangle_Oxford",
  "BrickKing_L_Triangle_SouthHampton",
  "BrickQueen_L_Cherokee_Augusta",
  "BrickQueen_L_Cherokee_Natchez",
  "BrickQueen_L_FAKE_Chalk",
  "BrickQueen_L_Meridian_Alamo",
  "BrickQueen_L_Meridian_AlpineSelect",
  "BrickQueen_L_Meridian_Baytown",
  "BrickQueen_L_Meridian_Belhaven",
  "BrickQueen_L_Meridian_Dover",
  "BrickQueen_L_Meridian_Laredo",
  "BrickQueen_L_Meridian_MtRushmore",
  "BrickQueen_L_Meridian_NorthHighland",
  "BrickQueen_L_Meridian_OldGuignard",
  "BrickQueen_L_Meridian_OldJackson",
  "BrickQueen_L_Meridian_SaltPlains",
  "BrickQueen_L_Meridian_ShadowFalls",
  "BrickQueen_L_Meridian_Smithsonian",
  "BrickQueen_L_Meridian_StAndrews",
  "BrickQueen_L_Meridian_StLorain",
  "BrickQueen_L_Meridian_SummerAsh",
  "BrickQueen_L_Paint_SW_SW_7068_GrizzleGray",
  "BrickQueen_L_Triangle_BessemerGray",
  "BrickQueen_L_Triangle_EvelynBay",
  "BrickQueen_L_Triangle_MountainBranchSelect",
  "BrickQueen_L_Triangle_Oxford",
  "BrickQueen_L_Triangle_SouthHampton",
  "Brick_03_L_CasaDaSassi_CdS_FullBrown",
  "Brick_03_L_Triangle_Northampton",
  "Brick_03_L_Triangle_OldColony",
  "Brick_05_L_CasaDaSassi_CdS_FullBrown",
  "Brick_05_L_Triangle_Northampton",
  "Brick_05_L_Triangle_OldColony",
  "BrickKing_L_CasaDaSassi_CdS_FullBrown",
  "BrickKing_L_Triangle_Northampton",
  "BrickKing_L_Triangle_OldColony",
  "BrickModular_L_CasaDaSassi_CdS_FullBrown",
  "BrickModular_L_Cherokee_Augusta",
  "BrickModular_L_Cherokee_Natchez",
  "BrickModular_L_FAKE_Chalk",
  "BrickModular_L_Meridian_Alamo",
  "BrickModular_L_Meridian_AlpineSelect",
  "BrickModular_L_Meridian_Baytown",
  "BrickModular_L_Meridian_Belhaven",
  "BrickModular_L_Meridian_Dover",
  "BrickModular_L_Meridian_Laredo",
  "BrickModular_L_Meridian_MtRushmore",
  "BrickModular_L_Meridian_NorthHighland",
  "BrickModular_L_Meridian_OldGuignard",
  "BrickModular_L_Meridian_OldJackson",
  "BrickModular_L_Meridian_SaltPlains",
  "BrickModular_L_Meridian_ShadowFalls",
  "BrickModular_L_Meridian_Smithsonian",
  "BrickModular_L_Meridian_StAndrews",
  "BrickModular_L_Meridian_StLorain",
  "BrickModular_L_Meridian_SummerAsh",
  "BrickModular_L_Paint_SW_SW_7068_GrizzleGray",
  "BrickModular_L_Triangle_BessemerGray",
  "BrickModular_L_Triangle_EvelynBay",
  "BrickModular_L_Triangle_MountainBranchSelect",
  "BrickModular_L_Triangle_Northampton",
  "BrickModular_L_Triangle_OldColony",
  "BrickModular_L_Triangle_Oxford",
  "BrickModular_L_Triangle_SouthHampton",
  "BrickQueen_L_CasaDaSassi_CdS_FullBrown",
  "BrickQueen_L_Triangle_Northampton",
  "BrickQueen_L_Triangle_OldColony",
  "Brick_03_L_Paint_SW_SW_6246_NorthStar",
  "Brick_03_L_Paint_SW_SW_9171_FeltedWool",
  "Brick_03_L_Paint_SW_SW_9174_MothWing",
  "Brick_05_L_Paint_SW_SW_6246_NorthStar",
  "Brick_05_L_Paint_SW_SW_9171_FeltedWool",
  "Brick_05_L_Paint_SW_SW_9174_MothWing",
  "Brick_075_L_CasaDaSassi_CdS_FullBrown",
  "Brick_075_L_Cherokee_Augusta",
  "Brick_075_L_Cherokee_Natchez",
  "Brick_075_L_FAKE_Chalk",
  "Brick_075_L_Meridian_Alamo",
  "Brick_075_L_Meridian_AlpineSelect",
  "Brick_075_L_Meridian_Baytown",
  "Brick_075_L_Meridian_Belhaven",
  "Brick_075_L_Meridian_Dover",
  "Brick_075_L_Meridian_Laredo",
  "Brick_075_L_Meridian_MtRushmore",
  "Brick_075_L_Meridian_NorthHighland",
  "Brick_075_L_Meridian_OldGuignard",
  "Brick_075_L_Meridian_OldJackson",
  "Brick_075_L_Meridian_SaltPlains",
  "Brick_075_L_Meridian_ShadowFalls",
  "Brick_075_L_Meridian_Smithsonian",
  "Brick_075_L_Meridian_StAndrews",
  "Brick_075_L_Meridian_StLorain",
  "Brick_075_L_Meridian_SummerAsh",
  "Brick_075_L_Paint_SW_SW_6246_NorthStar",
  "Brick_075_L_Paint_SW_SW_7068_GrizzleGray",
  "Brick_075_L_Paint_SW_SW_9171_FeltedWool",
  "Brick_075_L_Paint_SW_SW_9174_MothWing",
  "Brick_075_L_Triangle_BessemerGray",
  "Brick_075_L_Triangle_EvelynBay",
  "Brick_075_L_Triangle_MountainBranchSelect",
  "Brick_075_L_Triangle_Northampton",
  "Brick_075_L_Triangle_OldColony",
  "Brick_075_L_Triangle_Oxford",
  "Brick_075_L_Triangle_SouthHampton",
  "BrickKing_L_Acme_AdobeWells",
  "BrickKing_L_Acme_Frostwood",
  "BrickKing_L_Acme_ParkShadows",
  "BrickKing_L_Acme_Silverthorn",
  "BrickKing_L_Acme_StoneBay",
  "BrickKing_L_GlenGery_AntiqueWhite",
  "BrickKing_L_GlenGery_AztecWhite",
  "BrickKing_L_GlenGery_Birch",
  "BrickKing_L_GlenGery_Casablanca",
  "BrickKing_L_GlenGery_WilliamsburgBradford",
  "BrickKing_L_GlenGery_WilliamsburgCherryCreek",
  "BrickKing_L_GlenGery_WilliamsburgHampton",
  "BrickKing_L_Paint_SW_SW_6246_NorthStar",
  "BrickKing_L_Paint_SW_SW_9171_FeltedWool",
  "BrickKing_L_Paint_SW_SW_9174_MothWing",
  "BrickKing_L_RedRiver_AlpineFog",
  "BrickKing_L_RedRiver_CrescentGrove",
  "BrickKing_L_RedRiver_FireOak",
  "BrickKing_L_RedRiver_Glenwood",
  "BrickKing_L_RedRiver_SaltPlains",
  "BrickKing_L_RedRiver_ShadowFalls",
  "BrickKing_L_RedRiver_ShelteredBluff",
  "BrickKing_L_RedRiver_Tecomate",
  "BrickModular_L_Acme_AdobeWells",
  "BrickModular_L_Acme_Frostwood",
  "BrickModular_L_Acme_ParkShadows",
  "BrickModular_L_Acme_Silverthorn",
  "BrickModular_L_Acme_StoneBay",
  "BrickModular_L_GlenGery_AntiqueWhite",
  "BrickModular_L_GlenGery_AztecWhite",
  "BrickModular_L_GlenGery_Birch",
  "BrickModular_L_GlenGery_Casablanca",
  "BrickModular_L_GlenGery_WilliamsburgBradford",
  "BrickModular_L_GlenGery_WilliamsburgCherryCreek",
  "BrickModular_L_GlenGery_WilliamsburgHampton",
  "BrickModular_L_Paint_SW_SW_6246_NorthStar",
  "BrickModular_L_Paint_SW_SW_9171_FeltedWool",
  "BrickModular_L_Paint_SW_SW_9174_MothWing",
  "BrickModular_L_RedRiver_AlpineFog",
  "BrickModular_L_RedRiver_CrescentGrove",
  "BrickModular_L_RedRiver_FireOak",
  "BrickModular_L_RedRiver_Glenwood",
  "BrickModular_L_RedRiver_SaltPlains",
  "BrickModular_L_RedRiver_ShadowFalls",
  "BrickModular_L_RedRiver_ShelteredBluff",
  "BrickModular_L_RedRiver_Tecomate",
  "BrickQueen_L_Acme_AdobeWells",
  "BrickQueen_L_Acme_Frostwood",
  "BrickQueen_L_Acme_ParkShadows",
  "BrickQueen_L_Acme_Silverthorn",
  "BrickQueen_L_Acme_StoneBay",
  "BrickQueen_L_GlenGery_AntiqueWhite",
  "BrickQueen_L_GlenGery_AztecWhite",
  "BrickQueen_L_GlenGery_Birch",
  "BrickQueen_L_GlenGery_Casablanca",
  "BrickQueen_L_GlenGery_WilliamsburgBradford",
  "BrickQueen_L_GlenGery_WilliamsburgCherryCreek",
  "BrickQueen_L_GlenGery_WilliamsburgHampton",
  "BrickQueen_L_Paint_SW_SW_6246_NorthStar",
  "BrickQueen_L_Paint_SW_SW_9171_FeltedWool",
  "BrickQueen_L_Paint_SW_SW_9174_MothWing",
  "BrickQueen_L_RedRiver_AlpineFog",
  "BrickQueen_L_RedRiver_CrescentGrove",
  "BrickQueen_L_RedRiver_FireOak",
  "BrickQueen_L_RedRiver_Glenwood",
  "BrickQueen_L_RedRiver_SaltPlains",
  "BrickQueen_L_RedRiver_ShadowFalls",
  "BrickQueen_L_RedRiver_ShelteredBluff",
  "BrickQueen_L_RedRiver_Tecomate",
  "BrickKing_L_Lusco_PearlRiver",
  "BrickKing_L_RedRiver_WellsValley",
  "BrickModular_L_Lusco_PearlRiver",
  "BrickModular_L_RedRiver_WellsValley",
  "BrickQueen_L_Lusco_PearlRiver",
  "BrickQueen_L_RedRiver_WellsValley",
  "Brick_03_L_Meridian_ChimneyMountain",
  "Brick_03_L_Meridian_PortHuron",
  "Brick_05_L_Meridian_ChimneyMountain",
  "Brick_05_L_Meridian_PortHuron",
  "Brick_075_L_Meridian_ChimneyMountain",
  "Brick_075_L_Meridian_PortHuron",
  "BrickKing_L_Meridian_ChimneyMountain",
  "BrickKing_L_Meridian_PortHuron",
  "BrickModular_L_Meridian_ChimneyMountain",
  "BrickModular_L_Meridian_PortHuron",
  "BrickQueen_L_Meridian_ChimneyMountain",
  "BrickQueen_L_Meridian_PortHuron",
  "BrickKing_L_Acme_Augusta",
  "BrickKing_L_Acme_HamptonMill",
  "BrickKing_L_Acme_OysterBay",
  "BrickKing_L_Acme_PineRidge",
  "BrickKing_L_Acme_RapidFalls",
  "BrickKing_L_Acme_Scottsdale",
  "BrickModular_L_Acme_Augusta",
  "BrickModular_L_Acme_HamptonMill",
  "BrickModular_L_Acme_OysterBay",
  "BrickModular_L_Acme_PineRidge",
  "BrickModular_L_Acme_RapidFalls",
  "BrickModular_L_Acme_Scottsdale",
  "BrickQueen_L_Acme_Augusta",
  "BrickQueen_L_Acme_HamptonMill",
  "BrickQueen_L_Acme_OysterBay",
  "BrickQueen_L_Acme_PineRidge",
  "BrickQueen_L_Acme_RapidFalls",
  "BrickQueen_L_Acme_Scottsdale",
  "BrickKing_L_RedRiver_BurlingtonAntique",
  "BrickKing_L_RedRiver_Caprock",
  "BrickKing_L_RedRiver_CypressSprings",
  "BrickKing_L_RedRiver_Mayfield",
  "BrickKing_L_RedRiver_Ridgemont",
  "BrickKing_L_RedRiver_Silverado",
  "BrickModular_L_RedRiver_BurlingtonAntique",
  "BrickModular_L_RedRiver_Caprock",
  "BrickModular_L_RedRiver_CypressSprings",
  "BrickModular_L_RedRiver_Mayfield",
  "BrickModular_L_RedRiver_Ridgemont",
  "BrickModular_L_RedRiver_Silverado",
  "BrickQueen_L_RedRiver_BurlingtonAntique",
  "BrickQueen_L_RedRiver_Caprock",
  "BrickQueen_L_RedRiver_CypressSprings",
  "BrickQueen_L_RedRiver_Mayfield",
  "BrickQueen_L_RedRiver_Ridgemont",
  "BrickQueen_L_RedRiver_Silverado",
  "Brick_03_L_Paint_SW_SW_7004_Snowbound",
  "Brick_05_L_Paint_SW_SW_7004_Snowbound",
  "Brick_075_L_Paint_SW_SW_7004_Snowbound",
  "BrickKing_L_Paint_SW_SW_7004_Snowbound",
  "BrickModular_L_Paint_SW_SW_7004_Snowbound",
  "BrickQueen_L_Paint_SW_SW_7004_Snowbound",
  "BrickKing_L_RedRiver_Amarylis",
  "BrickModular_L_RedRiver_Amarylis",
  "BrickQueen_L_RedRiver_Amarylis",
  "Brick_03_L_GeneralShale_GS_Domino",
  "Brick_05_L_GeneralShale_GS_Domino",
  "Brick_075_L_GeneralShale_GS_Domino",
  "BrickKing_L_GeneralShale_GS_Domino",
  "BrickModular_L_GeneralShale_GS_Domino",
  "BrickQueen_L_GeneralShale_GS_Domino",
  "Brick_03_L_GeneralShale_GS_BourbonTrail",
  "Brick_03_L_GeneralShale_GS_CavalryGray",
  "Brick_03_L_GeneralShale_GS_NolinRiver",
  "Brick_05_L_GeneralShale_GS_BourbonTrail",
  "Brick_05_L_GeneralShale_GS_CavalryGray",
  "Brick_05_L_GeneralShale_GS_NolinRiver",
  "Brick_075_L_GeneralShale_GS_BourbonTrail",
  "Brick_075_L_GeneralShale_GS_CavalryGray",
  "Brick_075_L_GeneralShale_GS_NolinRiver",
  "BrickKing_L_GeneralShale_GS_BourbonTrail",
  "BrickKing_L_GeneralShale_GS_CavalryGray",
  "BrickKing_L_GeneralShale_GS_NolinRiver",
  "BrickModular_L_GeneralShale_GS_BourbonTrail",
  "BrickModular_L_GeneralShale_GS_CavalryGray",
  "BrickModular_L_GeneralShale_GS_NolinRiver",
  "BrickQueen_L_GeneralShale_GS_BourbonTrail",
  "BrickQueen_L_GeneralShale_GS_CavalryGray",
  "BrickQueen_L_GeneralShale_GS_NolinRiver",
  "Brick_03_L_GeneralShale_GS_SwanCreek",
  "Brick_03_L_HenryBrick_HB_CypressPoint",
  "Brick_05_L_GeneralShale_GS_SwanCreek",
  "Brick_05_L_HenryBrick_HB_CypressPoint",
  "Brick_075_L_GeneralShale_GS_SwanCreek",
  "Brick_075_L_HenryBrick_HB_CypressPoint",
  "BrickKing_L_GeneralShale_GS_SwanCreek",
  "BrickKing_L_HenryBrick_HB_CypressPoint",
  "BrickModular_L_GeneralShale_GS_SwanCreek",
  "BrickModular_L_HenryBrick_HB_CypressPoint",
  "BrickQueen_L_GeneralShale_GS_SwanCreek",
  "BrickQueen_L_HenryBrick_HB_CypressPoint",
  "Brick_03_L_Claymex_LeMont",
  "Brick_03_L_Claymex_Oxford",
  "Brick_03_L_Triangle_JeffersonPark",
  "Brick_03_L_Triangle_SeelyTown",
  "Brick_05_L_Claymex_LeMont",
  "Brick_05_L_Claymex_Oxford",
  "Brick_05_L_Triangle_JeffersonPark",
  "Brick_05_L_Triangle_SeelyTown",
  "Brick_075_L_Claymex_LeMont",
  "Brick_075_L_Claymex_Oxford",
  "Brick_075_L_Triangle_JeffersonPark",
  "Brick_075_L_Triangle_SeelyTown",
  "BrickKing_L_Claymex_LeMont",
  "BrickKing_L_Claymex_Oxford",
  "BrickKing_L_Triangle_JeffersonPark",
  "BrickKing_L_Triangle_SeelyTown",
  "BrickModular_L_Claymex_LeMont",
  "BrickModular_L_Claymex_Oxford",
  "BrickModular_L_Triangle_JeffersonPark",
  "BrickModular_L_Triangle_SeelyTown",
  "BrickQueen_L_Claymex_LeMont",
  "BrickQueen_L_Claymex_Oxford",
  "BrickQueen_L_Triangle_JeffersonPark",
  "BrickQueen_L_Triangle_SeelyTown",
  "Brick_03_L_Triangle_DoverWhite",
  "Brick_05_L_Triangle_DoverWhite",
  "Brick_075_L_Triangle_DoverWhite",
  "BrickKing_L_Triangle_DoverWhite",
  "BrickModular_L_Triangle_DoverWhite",
  "BrickQueen_L_Triangle_DoverWhite",
  "Brick_03_L_GeneralShale_GS_Ashview",
  "Brick_03_L_GeneralShale_GS_Winstar",
  "Brick_05_L_GeneralShale_GS_Ashview",
  "Brick_05_L_GeneralShale_GS_Winstar",
  "Brick_075_L_GeneralShale_GS_Ashview",
  "Brick_075_L_GeneralShale_GS_Winstar",
  "BrickKing_L_GeneralShale_GS_Ashview",
  "BrickKing_L_GeneralShale_GS_Winstar",
  "BrickModular_L_GeneralShale_GS_Ashview",
  "BrickModular_L_GeneralShale_GS_Winstar",
  "BrickQueen_L_GeneralShale_GS_Ashview",
  "BrickQueen_L_GeneralShale_GS_Winstar",
  "BrickKing_L_Acme_Brookstone",
  "BrickKing_L_Acme_MountainBrook",
  "BrickKing_L_Acme_Rockwell",
  "BrickModular_L_Acme_Brookstone",
  "BrickModular_L_Acme_MountainBrook",
  "BrickModular_L_Acme_Rockwell",
  "BrickQueen_L_Acme_Brookstone",
  "BrickQueen_L_Acme_MountainBrook",
  "BrickQueen_L_Acme_Rockwell",
  "Brick_03_L_Acme_AdobeWells",
  "Brick_03_L_Acme_Augusta",
  "Brick_03_L_Acme_Brookstone",
  "Brick_03_L_Acme_Frostwood",
  "Brick_03_L_Acme_GlacierBay",
  "Brick_03_L_Acme_HamptonMill",
  "Brick_03_L_Acme_Highstone",
  "Brick_03_L_Acme_MountainBrook",
  "Brick_03_L_Acme_OysterBay",
  "Brick_03_L_Acme_ParkShadows",
  "Brick_03_L_Acme_PineRidge",
  "Brick_03_L_Acme_RapidFalls",
  "Brick_03_L_Acme_Rockwell",
  "Brick_03_L_Acme_Scottsdale",
  "Brick_03_L_Acme_Silverthorn",
  "Brick_03_L_Acme_StoneBay",
  "Brick_03_L_Acme_WhiteRiverRock",
  "Brick_03_L_Bilco_Stardust",
  "Brick_03_L_GlenGery_AntiqueWhite",
  "Brick_03_L_GlenGery_AztecWhite",
  "Brick_03_L_GlenGery_Birch",
  "Brick_03_L_GlenGery_Casablanca",
  "Brick_03_L_GlenGery_WilliamsburgBradford",
  "Brick_03_L_GlenGery_WilliamsburgCherryCreek",
  "Brick_03_L_GlenGery_WilliamsburgHampton",
  "Brick_03_L_Lusco_PearlRiver",
  "Brick_03_L_RedRiver_AlpineFog",
  "Brick_03_L_RedRiver_Amarylis",
  "Brick_03_L_RedRiver_BurlingtonAntique",
  "Brick_03_L_RedRiver_Caprock",
  "Brick_03_L_RedRiver_CrescentGrove",
  "Brick_03_L_RedRiver_CypressSprings",
  "Brick_03_L_RedRiver_FireOak",
  "Brick_03_L_RedRiver_Glenwood",
  "Brick_03_L_RedRiver_Mayfield",
  "Brick_03_L_RedRiver_Ridgemont",
  "Brick_03_L_RedRiver_SaltPlains",
  "Brick_03_L_RedRiver_ShadowFalls",
  "Brick_03_L_RedRiver_ShelteredBluff",
  "Brick_03_L_RedRiver_Silverado",
  "Brick_03_L_RedRiver_Tecomate",
  "Brick_03_L_RedRiver_WellsValley",
  "Brick_05_L_Acme_AdobeWells",
  "Brick_05_L_Acme_Augusta",
  "Brick_05_L_Acme_Brookstone",
  "Brick_05_L_Acme_Frostwood",
  "Brick_05_L_Acme_GlacierBay",
  "Brick_05_L_Acme_HamptonMill",
  "Brick_05_L_Acme_Highstone",
  "Brick_05_L_Acme_MountainBrook",
  "Brick_05_L_Acme_OysterBay",
  "Brick_05_L_Acme_ParkShadows",
  "Brick_05_L_Acme_PineRidge",
  "Brick_05_L_Acme_RapidFalls",
  "Brick_05_L_Acme_Rockwell",
  "Brick_05_L_Acme_Scottsdale",
  "Brick_05_L_Acme_Silverthorn",
  "Brick_05_L_Acme_StoneBay",
  "Brick_05_L_Acme_WhiteRiverRock",
  "Brick_05_L_Bilco_Stardust",
  "Brick_05_L_GlenGery_AntiqueWhite",
  "Brick_05_L_GlenGery_AztecWhite",
  "Brick_05_L_GlenGery_Birch",
  "Brick_05_L_GlenGery_Casablanca",
  "Brick_05_L_GlenGery_WilliamsburgBradford",
  "Brick_05_L_GlenGery_WilliamsburgCherryCreek",
  "Brick_05_L_GlenGery_WilliamsburgHampton",
  "Brick_05_L_Lusco_PearlRiver",
  "Brick_05_L_RedRiver_AlpineFog",
  "Brick_05_L_RedRiver_Amarylis",
  "Brick_05_L_RedRiver_BurlingtonAntique",
  "Brick_05_L_RedRiver_Caprock",
  "Brick_05_L_RedRiver_CrescentGrove",
  "Brick_05_L_RedRiver_CypressSprings",
  "Brick_05_L_RedRiver_FireOak",
  "Brick_05_L_RedRiver_Glenwood",
  "Brick_05_L_RedRiver_Mayfield",
  "Brick_05_L_RedRiver_Ridgemont",
  "Brick_05_L_RedRiver_SaltPlains",
  "Brick_05_L_RedRiver_ShadowFalls",
  "Brick_05_L_RedRiver_ShelteredBluff",
  "Brick_05_L_RedRiver_Silverado",
  "Brick_05_L_RedRiver_Tecomate",
  "Brick_05_L_RedRiver_WellsValley",
  "Brick_075_L_Acme_AdobeWells",
  "Brick_075_L_Acme_Augusta",
  "Brick_075_L_Acme_Brookstone",
  "Brick_075_L_Acme_Frostwood",
  "Brick_075_L_Acme_GlacierBay",
  "Brick_075_L_Acme_HamptonMill",
  "Brick_075_L_Acme_Highstone",
  "Brick_075_L_Acme_MountainBrook",
  "Brick_075_L_Acme_OysterBay",
  "Brick_075_L_Acme_ParkShadows",
  "Brick_075_L_Acme_PineRidge",
  "Brick_075_L_Acme_RapidFalls",
  "Brick_075_L_Acme_Rockwell",
  "Brick_075_L_Acme_Scottsdale",
  "Brick_075_L_Acme_Silverthorn",
  "Brick_075_L_Acme_StoneBay",
  "Brick_075_L_Acme_WhiteRiverRock",
  "Brick_075_L_Bilco_Stardust",
  "Brick_075_L_GlenGery_AntiqueWhite",
  "Brick_075_L_GlenGery_AztecWhite",
  "Brick_075_L_GlenGery_Birch",
  "Brick_075_L_GlenGery_Casablanca",
  "Brick_075_L_GlenGery_WilliamsburgBradford",
  "Brick_075_L_GlenGery_WilliamsburgCherryCreek",
  "Brick_075_L_GlenGery_WilliamsburgHampton",
  "Brick_075_L_Lusco_PearlRiver",
  "Brick_075_L_RedRiver_AlpineFog",
  "Brick_075_L_RedRiver_Amarylis",
  "Brick_075_L_RedRiver_BurlingtonAntique",
  "Brick_075_L_RedRiver_Caprock",
  "Brick_075_L_RedRiver_CrescentGrove",
  "Brick_075_L_RedRiver_CypressSprings",
  "Brick_075_L_RedRiver_FireOak",
  "Brick_075_L_RedRiver_Glenwood",
  "Brick_075_L_RedRiver_Mayfield",
  "Brick_075_L_RedRiver_Ridgemont",
  "Brick_075_L_RedRiver_SaltPlains",
  "Brick_075_L_RedRiver_ShadowFalls",
  "Brick_075_L_RedRiver_ShelteredBluff",
  "Brick_075_L_RedRiver_Silverado",
  "Brick_075_L_RedRiver_Tecomate",
  "Brick_075_L_RedRiver_WellsValley",
  "BrickKing_L_Acme_GlacierBay",
  "BrickKing_L_Acme_Highstone",
  "BrickKing_L_Acme_WhiteRiverRock",
  "BrickKing_L_Bilco_Stardust",
  "BrickModular_L_Acme_GlacierBay",
  "BrickModular_L_Acme_Highstone",
  "BrickModular_L_Acme_WhiteRiverRock",
  "BrickModular_L_Bilco_Stardust",
  "BrickQueen_L_Acme_GlacierBay",
  "BrickQueen_L_Acme_Highstone",
  "BrickQueen_L_Acme_WhiteRiverRock",
  "BrickQueen_L_Bilco_Stardust",
  "Brick_03_L_Acme_ForestHills",
  "Brick_03_L_Acme_SanJose",
  "Brick_03_L_Acme_Seabrook",
  "Brick_05_L_Acme_ForestHills",
  "Brick_05_L_Acme_SanJose",
  "Brick_05_L_Acme_Seabrook",
  "Brick_075_L_Acme_ForestHills",
  "Brick_075_L_Acme_SanJose",
  "Brick_075_L_Acme_Seabrook",
  "BrickKing_L_Acme_ForestHills",
  "BrickKing_L_Acme_SanJose",
  "BrickKing_L_Acme_Seabrook",
  "BrickModular_L_Acme_ForestHills",
  "BrickModular_L_Acme_SanJose",
  "BrickModular_L_Acme_Seabrook",
  "BrickQueen_L_Acme_ForestHills",
  "BrickQueen_L_Acme_SanJose",
  "BrickQueen_L_Acme_Seabrook",
  "Brick_03_L_USBrick_Blackberry",
  "Brick_05_L_USBrick_Blackberry",
  "Brick_075_L_USBrick_Blackberry",
  "BrickKing_L_USBrick_Blackberry",
  "BrickModular_L_USBrick_Blackberry",
  "BrickQueen_L_USBrick_Blackberry",
  "Brick_03_L_GeneralShale_GS_BarnsleyTudor",
  "Brick_03_L_GeneralShale_GS_KeenelandElite",
  "Brick_03_L_GeneralShale_GS_ManorHouseTudor",
  "Brick_03_L_GeneralShale_GS_ShadowGrey",
  "Brick_05_L_GeneralShale_GS_BarnsleyTudor",
  "Brick_05_L_GeneralShale_GS_KeenelandElite",
  "Brick_05_L_GeneralShale_GS_ManorHouseTudor",
  "Brick_05_L_GeneralShale_GS_ShadowGrey",
  "Brick_075_L_GeneralShale_GS_BarnsleyTudor",
  "Brick_075_L_GeneralShale_GS_KeenelandElite",
  "Brick_075_L_GeneralShale_GS_ManorHouseTudor",
  "Brick_075_L_GeneralShale_GS_ShadowGrey",
  "BrickKing_L_GeneralShale_GS_BarnsleyTudor",
  "BrickKing_L_GeneralShale_GS_KeenelandElite",
  "BrickKing_L_GeneralShale_GS_ManorHouseTudor",
  "BrickKing_L_GeneralShale_GS_ShadowGrey",
  "BrickModular_L_GeneralShale_GS_BarnsleyTudor",
  "BrickModular_L_GeneralShale_GS_KeenelandElite",
  "BrickModular_L_GeneralShale_GS_ManorHouseTudor",
  "BrickModular_L_GeneralShale_GS_ShadowGrey",
  "BrickQueen_L_GeneralShale_GS_BarnsleyTudor",
  "BrickQueen_L_GeneralShale_GS_KeenelandElite",
  "BrickQueen_L_GeneralShale_GS_ManorHouseTudor",
  "BrickQueen_L_GeneralShale_GS_ShadowGrey",
  "Brick_03_L_Acme_FrenchChateaux",
  "Brick_03_L_Acme_MochaBrownAntique",
  "Brick_03_L_Binsa_AmericanAntique",
  "Brick_03_L_Binsa_HillStone",
  "Brick_03_L_RedRiver_GlisteningSprings",
  "Brick_03_L_Triangle_Porter",
  "Brick_05_L_Acme_FrenchChateaux",
  "Brick_05_L_Acme_MochaBrownAntique",
  "Brick_05_L_Binsa_AmericanAntique",
  "Brick_05_L_Binsa_HillStone",
  "Brick_05_L_RedRiver_GlisteningSprings",
  "Brick_05_L_Triangle_Porter",
  "Brick_075_L_Acme_FrenchChateaux",
  "Brick_075_L_Acme_MochaBrownAntique",
  "Brick_075_L_Binsa_AmericanAntique",
  "Brick_075_L_Binsa_HillStone",
  "Brick_075_L_RedRiver_GlisteningSprings",
  "Brick_075_L_Triangle_Porter",
  "BrickKing_L_Acme_FrenchChateaux",
  "BrickKing_L_Acme_MochaBrownAntique",
  "BrickKing_L_Binsa_AmericanAntique",
  "BrickKing_L_Binsa_HillStone",
  "BrickKing_L_RedRiver_GlisteningSprings",
  "BrickKing_L_Triangle_Porter",
  "BrickModular_L_Acme_FrenchChateaux",
  "BrickModular_L_Acme_MochaBrownAntique",
  "BrickModular_L_Binsa_AmericanAntique",
  "BrickModular_L_Binsa_HillStone",
  "BrickModular_L_RedRiver_GlisteningSprings",
  "BrickModular_L_Triangle_Porter",
  "BrickQueen_L_Acme_FrenchChateaux",
  "BrickQueen_L_Acme_MochaBrownAntique",
  "BrickQueen_L_Binsa_AmericanAntique",
  "BrickQueen_L_Binsa_HillStone",
  "BrickQueen_L_RedRiver_GlisteningSprings",
  "BrickQueen_L_Triangle_Porter",
  "Brick_03_L_GeneralShale_GS_AlpineSelect",
  "Brick_03_L_GeneralShale_GS_VintagePort",
  "Brick_03_L_GeneralShale_GS_Wynnewood",
  "Brick_05_L_GeneralShale_GS_AlpineSelect",
  "Brick_05_L_GeneralShale_GS_VintagePort",
  "Brick_05_L_GeneralShale_GS_Wynnewood",
  "Brick_075_L_GeneralShale_GS_AlpineSelect",
  "Brick_075_L_GeneralShale_GS_VintagePort",
  "Brick_075_L_GeneralShale_GS_Wynnewood",
  "BrickKing_L_GeneralShale_GS_AlpineSelect",
  "BrickKing_L_GeneralShale_GS_VintagePort",
  "BrickKing_L_GeneralShale_GS_Wynnewood",
  "BrickModular_L_GeneralShale_GS_AlpineSelect",
  "BrickModular_L_GeneralShale_GS_VintagePort",
  "BrickModular_L_GeneralShale_GS_Wynnewood",
  "BrickQueen_L_GeneralShale_GS_AlpineSelect",
  "BrickQueen_L_GeneralShale_GS_VintagePort",
  "BrickQueen_L_GeneralShale_GS_Wynnewood",
  "Brick_03_L_GeneralShale_GS_NewcastleGray",
  "Brick_05_L_GeneralShale_GS_NewcastleGray",
  "Brick_075_L_GeneralShale_GS_NewcastleGray",
  "BrickKing_L_GeneralShale_GS_NewcastleGray",
  "BrickModular_L_GeneralShale_GS_NewcastleGray",
  "BrickQueen_L_GeneralShale_GS_NewcastleGray",
  "Brick_03_L_GeneralShale_GS_OldEdisto",
  "Brick_05_L_GeneralShale_GS_OldEdisto",
  "Brick_075_L_GeneralShale_GS_OldEdisto",
  "BrickKing_L_GeneralShale_GS_OldEdisto",
  "BrickModular_L_GeneralShale_GS_OldEdisto",
  "BrickQueen_L_GeneralShale_GS_OldEdisto",
  "BrickExecutive_L_Acme_AdobeWells",
  "BrickExecutive_L_Acme_Augusta",
  "BrickExecutive_L_Acme_Brookstone",
  "BrickExecutive_L_Acme_ForestHills",
  "BrickExecutive_L_Acme_FrenchChateaux",
  "BrickExecutive_L_Acme_Frostwood",
  "BrickExecutive_L_Acme_GlacierBay",
  "BrickExecutive_L_Acme_HamptonMill",
  "BrickExecutive_L_Acme_Highstone",
  "BrickExecutive_L_Acme_MochaBrownAntique",
  "BrickExecutive_L_Acme_MountainBrook",
  "BrickExecutive_L_Acme_OysterBay",
  "BrickExecutive_L_Acme_ParkShadows",
  "BrickExecutive_L_Acme_PineRidge",
  "BrickExecutive_L_Acme_RapidFalls",
  "BrickExecutive_L_Acme_Rockwell",
  "BrickExecutive_L_Acme_SanJose",
  "BrickExecutive_L_Acme_Scottsdale",
  "BrickExecutive_L_Acme_Seabrook",
  "BrickExecutive_L_Acme_Silverthorn",
  "BrickExecutive_L_Acme_StoneBay",
  "BrickExecutive_L_Acme_WhiteRiverRock",
  "BrickExecutive_L_Bilco_Stardust",
  "BrickExecutive_L_Binsa_AmericanAntique",
  "BrickExecutive_L_Binsa_HillStone",
  "BrickExecutive_L_CasaDaSassi_CdS_FullBrown",
  "BrickExecutive_L_Cherokee_Augusta",
  "BrickExecutive_L_Cherokee_Natchez",
  "BrickExecutive_L_Claymex_LeMont",
  "BrickExecutive_L_Claymex_Oxford",
  "BrickExecutive_L_FAKE_Chalk",
  "BrickExecutive_L_GeneralShale_GS_AlpineSelect",
  "BrickExecutive_L_GeneralShale_GS_Ashview",
  "BrickExecutive_L_GeneralShale_GS_BarnsleyTudor",
  "BrickExecutive_L_GeneralShale_GS_BourbonTrail",
  "BrickExecutive_L_GeneralShale_GS_CavalryGray",
  "BrickExecutive_L_GeneralShale_GS_Domino",
  "BrickExecutive_L_GeneralShale_GS_KeenelandElite",
  "BrickExecutive_L_GeneralShale_GS_ManorHouseTudor",
  "BrickExecutive_L_GeneralShale_GS_NewcastleGray",
  "BrickExecutive_L_GeneralShale_GS_NolinRiver",
  "BrickExecutive_L_GeneralShale_GS_OldEdisto",
  "BrickExecutive_L_GeneralShale_GS_ShadowGrey",
  "BrickExecutive_L_GeneralShale_GS_SwanCreek",
  "BrickExecutive_L_GeneralShale_GS_VintagePort",
  "BrickExecutive_L_GeneralShale_GS_Winstar",
  "BrickExecutive_L_GeneralShale_GS_Wynnewood",
  "BrickExecutive_L_GlenGery_AntiqueWhite",
  "BrickExecutive_L_GlenGery_AztecWhite",
  "BrickExecutive_L_GlenGery_Birch",
  "BrickExecutive_L_GlenGery_Casablanca",
  "BrickExecutive_L_GlenGery_WilliamsburgBradford",
  "BrickExecutive_L_GlenGery_WilliamsburgCherryCreek",
  "BrickExecutive_L_GlenGery_WilliamsburgHampton",
  "BrickExecutive_L_HenryBrick_HB_CypressPoint",
  "BrickExecutive_L_Lusco_PearlRiver",
  "BrickExecutive_L_Meridian_Alamo",
  "BrickExecutive_L_Meridian_AlpineSelect",
  "BrickExecutive_L_Meridian_Baytown",
  "BrickExecutive_L_Meridian_Belhaven",
  "BrickExecutive_L_Meridian_ChimneyMountain",
  "BrickExecutive_L_Meridian_Dover",
  "BrickExecutive_L_Meridian_Laredo",
  "BrickExecutive_L_Meridian_MtRushmore",
  "BrickExecutive_L_Meridian_NorthHighland",
  "BrickExecutive_L_Meridian_OldGuignard",
  "BrickExecutive_L_Meridian_OldJackson",
  "BrickExecutive_L_Meridian_PortHuron",
  "BrickExecutive_L_Meridian_SaltPlains",
  "BrickExecutive_L_Meridian_ShadowFalls",
  "BrickExecutive_L_Meridian_Smithsonian",
  "BrickExecutive_L_Meridian_StAndrews",
  "BrickExecutive_L_Meridian_StLorain",
  "BrickExecutive_L_Meridian_SummerAsh",
  "BrickExecutive_L_Paint_SW_SW_6246_NorthStar",
  "BrickExecutive_L_Paint_SW_SW_7004_Snowbound",
  "BrickExecutive_L_Paint_SW_SW_7068_GrizzleGray",
  "BrickExecutive_L_Paint_SW_SW_9171_FeltedWool",
  "BrickExecutive_L_Paint_SW_SW_9174_MothWing",
  "BrickExecutive_L_RedRiver_AlpineFog",
  "BrickExecutive_L_RedRiver_Amarylis",
  "BrickExecutive_L_RedRiver_BurlingtonAntique",
  "BrickExecutive_L_RedRiver_Caprock",
  "BrickExecutive_L_RedRiver_CrescentGrove",
  "BrickExecutive_L_RedRiver_CypressSprings",
  "BrickExecutive_L_RedRiver_FireOak",
  "BrickExecutive_L_RedRiver_Glenwood",
  "BrickExecutive_L_RedRiver_GlisteningSprings",
  "BrickExecutive_L_RedRiver_Mayfield",
  "BrickExecutive_L_RedRiver_Ridgemont",
  "BrickExecutive_L_RedRiver_SaltPlains",
  "BrickExecutive_L_RedRiver_ShadowFalls",
  "BrickExecutive_L_RedRiver_ShelteredBluff",
  "BrickExecutive_L_RedRiver_Silverado",
  "BrickExecutive_L_RedRiver_Tecomate",
  "BrickExecutive_L_RedRiver_WellsValley",
  "BrickExecutive_L_Triangle_BessemerGray",
  "BrickExecutive_L_Triangle_DoverWhite",
  "BrickExecutive_L_Triangle_EvelynBay",
  "BrickExecutive_L_Triangle_JeffersonPark",
  "BrickExecutive_L_Triangle_MountainBranchSelect",
  "BrickExecutive_L_Triangle_Northampton",
  "BrickExecutive_L_Triangle_OldColony",
  "BrickExecutive_L_Triangle_Oxford",
  "BrickExecutive_L_Triangle_Porter",
  "BrickExecutive_L_Triangle_SeelyTown",
  "BrickExecutive_L_Triangle_SouthHampton",
  "BrickExecutive_L_USBrick_Blackberry",
  "Brick_03_L_Acme_CasaBlanca",
  "Brick_03_L_Acme_Silvercreek",
  "Brick_03_L_Bilco_Everest",
  "Brick_03_L_Bilco_GrayMist",
  "Brick_03_L_Bilco_Scottsdale",
  "Brick_03_L_RedRiver_FoggyMorning",
  "Brick_03_L_RedRiver_SnowMist",
  "Brick_03_L_RedRiver_WhiteRiverRock",
  "Brick_05_L_Acme_CasaBlanca",
  "Brick_05_L_Acme_Silvercreek",
  "Brick_05_L_Bilco_Everest",
  "Brick_05_L_Bilco_GrayMist",
  "Brick_05_L_Bilco_Scottsdale",
  "Brick_05_L_RedRiver_FoggyMorning",
  "Brick_05_L_RedRiver_SnowMist",
  "Brick_05_L_RedRiver_WhiteRiverRock",
  "Brick_075_L_Acme_CasaBlanca",
  "Brick_075_L_Acme_Silvercreek",
  "Brick_075_L_Bilco_Everest",
  "Brick_075_L_Bilco_GrayMist",
  "Brick_075_L_Bilco_Scottsdale",
  "Brick_075_L_RedRiver_FoggyMorning",
  "Brick_075_L_RedRiver_SnowMist",
  "Brick_075_L_RedRiver_WhiteRiverRock",
  "BrickExecutive_L_Acme_CasaBlanca",
  "BrickExecutive_L_Acme_Silvercreek",
  "BrickExecutive_L_Bilco_Everest",
  "BrickExecutive_L_Bilco_GrayMist",
  "BrickExecutive_L_Bilco_Scottsdale",
  "BrickExecutive_L_RedRiver_FoggyMorning",
  "BrickExecutive_L_RedRiver_SnowMist",
  "BrickExecutive_L_RedRiver_WhiteRiverRock",
  "BrickKing_L_Acme_CasaBlanca",
  "BrickKing_L_Acme_Silvercreek",
  "BrickKing_L_Bilco_Everest",
  "BrickKing_L_Bilco_GrayMist",
  "BrickKing_L_Bilco_Scottsdale",
  "BrickKing_L_RedRiver_FoggyMorning",
  "BrickKing_L_RedRiver_SnowMist",
  "BrickKing_L_RedRiver_WhiteRiverRock",
  "BrickModular_L_Acme_CasaBlanca",
  "BrickModular_L_Acme_Silvercreek",
  "BrickModular_L_Bilco_Everest",
  "BrickModular_L_Bilco_GrayMist",
  "BrickModular_L_Bilco_Scottsdale",
  "BrickModular_L_RedRiver_FoggyMorning",
  "BrickModular_L_RedRiver_SnowMist",
  "BrickModular_L_RedRiver_WhiteRiverRock",
  "BrickQueen_L_Acme_CasaBlanca",
  "BrickQueen_L_Acme_Silvercreek",
  "BrickQueen_L_Bilco_Everest",
  "BrickQueen_L_Bilco_GrayMist",
  "BrickQueen_L_Bilco_Scottsdale",
  "BrickQueen_L_RedRiver_FoggyMorning",
  "BrickQueen_L_RedRiver_SnowMist",
  "BrickQueen_L_RedRiver_WhiteRiverRock",
  "Brick_03_L_Acme_CameronHills",
  "Brick_03_L_Acme_DentonAntique",
  "Brick_03_L_Acme_OldFrancisco",
  "Brick_03_L_Acme_Winterstone",
  "Brick_05_L_Acme_CameronHills",
  "Brick_05_L_Acme_DentonAntique",
  "Brick_05_L_Acme_OldFrancisco",
  "Brick_05_L_Acme_Winterstone",
  "Brick_075_L_Acme_CameronHills",
  "Brick_075_L_Acme_DentonAntique",
  "Brick_075_L_Acme_OldFrancisco",
  "Brick_075_L_Acme_Winterstone",
  "BrickExecutive_L_Acme_CameronHills",
  "BrickExecutive_L_Acme_DentonAntique",
  "BrickExecutive_L_Acme_OldFrancisco",
  "BrickExecutive_L_Acme_Winterstone",
  "BrickKing_L_Acme_CameronHills",
  "BrickKing_L_Acme_DentonAntique",
  "BrickKing_L_Acme_OldFrancisco",
  "BrickKing_L_Acme_Winterstone",
  "BrickModular_L_Acme_CameronHills",
  "BrickModular_L_Acme_DentonAntique",
  "BrickModular_L_Acme_OldFrancisco",
  "BrickModular_L_Acme_Winterstone",
  "BrickQueen_L_Acme_CameronHills",
  "BrickQueen_L_Acme_DentonAntique",
  "BrickQueen_L_Acme_OldFrancisco",
  "BrickQueen_L_Acme_Winterstone",
  "Brick_03_L_Acme_Callisburg",
  "Brick_05_L_Acme_Callisburg",
  "Brick_075_L_Acme_Callisburg",
  "BrickExecutive_L_Acme_Callisburg",
  "BrickKing_L_Acme_Callisburg",
  "BrickModular_L_Acme_Callisburg",
  "BrickQueen_L_Acme_Callisburg",
  "Brick_03_L_GeneralShale_GS_SpanishMoss",
  "Brick_03_L_Triangle_FortMill",
  "Brick_03_L_Triangle_LibbyMill",
  "Brick_05_L_GeneralShale_GS_SpanishMoss",
  "Brick_05_L_Triangle_FortMill",
  "Brick_05_L_Triangle_LibbyMill",
  "Brick_075_L_GeneralShale_GS_SpanishMoss",
  "Brick_075_L_Triangle_FortMill",
  "Brick_075_L_Triangle_LibbyMill",
  "BrickExecutive_L_GeneralShale_GS_SpanishMoss",
  "BrickExecutive_L_Triangle_FortMill",
  "BrickExecutive_L_Triangle_LibbyMill",
  "BrickKing_L_GeneralShale_GS_SpanishMoss",
  "BrickKing_L_Triangle_FortMill",
  "BrickKing_L_Triangle_LibbyMill",
  "BrickModular_L_GeneralShale_GS_SpanishMoss",
  "BrickModular_L_Triangle_FortMill",
  "BrickModular_L_Triangle_LibbyMill",
  "BrickQueen_L_GeneralShale_GS_SpanishMoss",
  "BrickQueen_L_Triangle_FortMill",
  "BrickQueen_L_Triangle_LibbyMill",
  "Brick_03_L_GeneralShale_GS_CapersIsland",
  "Brick_03_L_GeneralShale_GS_StoneMountain",
  "Brick_05_L_GeneralShale_GS_CapersIsland",
  "Brick_05_L_GeneralShale_GS_StoneMountain",
  "Brick_075_L_GeneralShale_GS_CapersIsland",
  "Brick_075_L_GeneralShale_GS_StoneMountain",
  "BrickExecutive_L_GeneralShale_GS_CapersIsland",
  "BrickExecutive_L_GeneralShale_GS_StoneMountain",
  "BrickKing_L_GeneralShale_GS_CapersIsland",
  "BrickKing_L_GeneralShale_GS_StoneMountain",
  "BrickModular_L_GeneralShale_GS_CapersIsland",
  "BrickModular_L_GeneralShale_GS_StoneMountain",
  "BrickQueen_L_GeneralShale_GS_CapersIsland",
  "BrickQueen_L_GeneralShale_GS_StoneMountain",
  "Brick_03_L_GeneralShale_GS_HeritageTrail",
  "Brick_05_L_GeneralShale_GS_HeritageTrail",
  "Brick_075_L_GeneralShale_GS_HeritageTrail",
  "BrickExecutive_L_GeneralShale_GS_HeritageTrail",
  "BrickKing_L_GeneralShale_GS_HeritageTrail",
  "BrickModular_L_GeneralShale_GS_HeritageTrail",
  "BrickQueen_L_GeneralShale_GS_HeritageTrail",
  "Brick_03_L_Claymex_Alpine",
  "Brick_05_L_Claymex_Alpine",
  "Brick_075_L_Claymex_Alpine",
  "BrickExecutive_L_Claymex_Alpine",
  "BrickKing_L_Claymex_Alpine",
  "BrickModular_L_Claymex_Alpine",
  "BrickQueen_L_Claymex_Alpine",
  "Brick_03_L_Claymex_Brownfield",
  "Brick_05_L_Claymex_Brownfield",
  "Brick_075_L_Claymex_Brownfield",
  "BrickExecutive_L_Claymex_Brownfield",
  "BrickKing_L_Claymex_Brownfield",
  "BrickModular_L_Claymex_Brownfield",
  "BrickQueen_L_Claymex_Brownfield",
  "Brick_03_L_Claymex_Cobblestone",
  "Brick_05_L_Claymex_Cobblestone",
  "Brick_075_L_Claymex_Cobblestone",
  "BrickExecutive_L_Claymex_Cobblestone",
  "BrickKing_L_Claymex_Cobblestone",
  "BrickModular_L_Claymex_Cobblestone",
  "BrickQueen_L_Claymex_Cobblestone",
  "Brick_03_L_Claymex_Keystone",
  "Brick_05_L_Claymex_Keystone",
  "Brick_075_L_Claymex_Keystone",
  "BrickExecutive_L_Claymex_Keystone",
  "BrickKing_L_Claymex_Keystone",
  "BrickModular_L_Claymex_Keystone",
  "BrickQueen_L_Claymex_Keystone",
  "Brick_03_L_Claymex_Onyx",
  "Brick_05_L_Claymex_Onyx",
  "Brick_075_L_Claymex_Onyx",
  "BrickExecutive_L_Claymex_Onyx",
  "BrickKing_L_Claymex_Onyx",
  "BrickModular_L_Claymex_Onyx",
  "BrickQueen_L_Claymex_Onyx",
  "Brick_03_L_Claymex_Pewter",
  "Brick_05_L_Claymex_Pewter",
  "Brick_075_L_Claymex_Pewter",
  "BrickExecutive_L_Claymex_Pewter",
  "BrickKing_L_Claymex_Pewter",
  "BrickModular_L_Claymex_Pewter",
  "BrickQueen_L_Claymex_Pewter",
  "Brick_03_L_Claymex_Woodcreek",
  "Brick_05_L_Claymex_Woodcreek",
  "Brick_075_L_Claymex_Woodcreek",
  "BrickExecutive_L_Claymex_Woodcreek",
  "BrickKing_L_Claymex_Woodcreek",
  "BrickModular_L_Claymex_Woodcreek",
  "BrickQueen_L_Claymex_Woodcreek",
  "Brick_03_L_Claymex_York",
  "Brick_05_L_Claymex_York",
  "Brick_075_L_Claymex_York",
  "BrickExecutive_L_Claymex_York",
  "BrickKing_L_Claymex_York",
  "BrickModular_L_Claymex_York",
  "BrickQueen_L_Claymex_York",
  "Brick_03_L_PGH_Bark",
  "Brick_03_L_PGH_CharacterPutty",
  "Brick_03_L_PGH_CharacterRedRock",
  "Brick_05_L_PGH_Bark",
  "Brick_05_L_PGH_CharacterPutty",
  "Brick_05_L_PGH_CharacterRedRock",
  "Brick_075_L_PGH_Bark",
  "Brick_075_L_PGH_CharacterPutty",
  "Brick_075_L_PGH_CharacterRedRock",
  "BrickExecutive_L_PGH_Bark",
  "BrickExecutive_L_PGH_CharacterPutty",
  "BrickExecutive_L_PGH_CharacterRedRock",
  "BrickKing_L_PGH_Bark",
  "BrickKing_L_PGH_CharacterPutty",
  "BrickKing_L_PGH_CharacterRedRock",
  "BrickModular_L_PGH_Bark",
  "BrickModular_L_PGH_CharacterPutty",
  "BrickModular_L_PGH_CharacterRedRock",
  "BrickQueen_L_PGH_Bark",
  "BrickQueen_L_PGH_CharacterPutty",
  "BrickQueen_L_PGH_CharacterRedRock",
  "Brick_03_L_Harristone_Charleston",
  "Brick_03_L_Harristone_DoveGrey",
  "Brick_03_L_Harristone_WhiteSand",
  "Brick_05_L_Harristone_Charleston",
  "Brick_05_L_Harristone_DoveGrey",
  "Brick_05_L_Harristone_WhiteSand",
  "Brick_075_L_Harristone_Charleston",
  "Brick_075_L_Harristone_DoveGrey",
  "Brick_075_L_Harristone_WhiteSand",
  "BrickExecutive_L_Harristone_Charleston",
  "BrickExecutive_L_Harristone_DoveGrey",
  "BrickExecutive_L_Harristone_WhiteSand",
  "BrickKing_L_Harristone_Charleston",
  "BrickKing_L_Harristone_DoveGrey",
  "BrickKing_L_Harristone_WhiteSand",
  "BrickModular_L_Harristone_Charleston",
  "BrickModular_L_Harristone_DoveGrey",
  "BrickModular_L_Harristone_WhiteSand",
  "BrickQueen_L_Harristone_Charleston",
  "BrickQueen_L_Harristone_DoveGrey",
  "BrickQueen_L_Harristone_WhiteSand",
  "Brick_03_L_Bilco_Camel",
  "Brick_03_L_Bilco_Graystone",
  "Brick_03_L_Bilco_Onyx",
  "Brick_03_L_Bilco_Phoenix",
  "Brick_05_L_Bilco_Camel",
  "Brick_05_L_Bilco_Graystone",
  "Brick_05_L_Bilco_Onyx",
  "Brick_05_L_Bilco_Phoenix",
  "Brick_075_L_Bilco_Camel",
  "Brick_075_L_Bilco_Graystone",
  "Brick_075_L_Bilco_Onyx",
  "Brick_075_L_Bilco_Phoenix",
  "BrickExecutive_L_Bilco_Camel",
  "BrickExecutive_L_Bilco_Graystone",
  "BrickExecutive_L_Bilco_Onyx",
  "BrickExecutive_L_Bilco_Phoenix",
  "BrickKing_L_Bilco_Camel",
  "BrickKing_L_Bilco_Graystone",
  "BrickKing_L_Bilco_Onyx",
  "BrickKing_L_Bilco_Phoenix",
  "BrickModular_L_Bilco_Camel",
  "BrickModular_L_Bilco_Graystone",
  "BrickModular_L_Bilco_Onyx",
  "BrickModular_L_Bilco_Phoenix",
  "BrickQueen_L_Bilco_Camel",
  "BrickQueen_L_Bilco_Graystone",
  "BrickQueen_L_Bilco_Onyx",
  "BrickQueen_L_Bilco_Phoenix",
  "Brick_03_L_ProVia_Boston",
  "Brick_03_L_ProVia_Cobblestone",
  "Brick_03_L_ProVia_Delaware",
  "Brick_03_L_ProVia_Midnight",
  "Brick_05_L_ProVia_Boston",
  "Brick_05_L_ProVia_Cobblestone",
  "Brick_05_L_ProVia_Delaware",
  "Brick_05_L_ProVia_Midnight",
  "Brick_075_L_ProVia_Boston",
  "Brick_075_L_ProVia_Cobblestone",
  "Brick_075_L_ProVia_Delaware",
  "Brick_075_L_ProVia_Midnight",
  "BrickExecutive_L_ProVia_Boston",
  "BrickExecutive_L_ProVia_Cobblestone",
  "BrickExecutive_L_ProVia_Delaware",
  "BrickExecutive_L_ProVia_Midnight",
  "BrickKing_L_ProVia_Boston",
  "BrickKing_L_ProVia_Cobblestone",
  "BrickKing_L_ProVia_Delaware",
  "BrickKing_L_ProVia_Midnight",
  "BrickModular_L_ProVia_Boston",
  "BrickModular_L_ProVia_Cobblestone",
  "BrickModular_L_ProVia_Delaware",
  "BrickModular_L_ProVia_Midnight",
  "BrickQueen_L_ProVia_Boston",
  "BrickQueen_L_ProVia_Cobblestone",
  "BrickQueen_L_ProVia_Delaware",
  "BrickQueen_L_ProVia_Midnight",
  "Brick_03_L_Heritage_Ashwood",
  "Brick_05_L_Heritage_Ashwood",
  "Brick_075_L_Heritage_Ashwood",
  "BrickExecutive_L_Heritage_Ashwood",
  "BrickKing_L_Heritage_Ashwood",
  "BrickModular_L_Heritage_Ashwood",
  "BrickQueen_L_Heritage_Ashwood",
  "Brick_03_L_GeneralShale_GS_Cortez",
  "Brick_05_L_GeneralShale_GS_Cortez",
  "Brick_075_L_GeneralShale_GS_Cortez",
  "BrickExecutive_L_GeneralShale_GS_Cortez",
  "BrickKing_L_GeneralShale_GS_Cortez",
  "BrickModular_L_GeneralShale_GS_Cortez",
  "BrickQueen_L_GeneralShale_GS_Cortez",
  "Brick_03_L_USBrick_Monaco",
  "Brick_05_L_USBrick_Monaco",
  "Brick_075_L_USBrick_Monaco",
  "BrickExecutive_L_USBrick_Monaco",
  "BrickKing_L_USBrick_Monaco",
  "BrickModular_L_USBrick_Monaco",
  "BrickQueen_L_USBrick_Monaco",
  "Brick_03_L_GeneralShale_GS_BradfordHall",
  "Brick_05_L_GeneralShale_GS_BradfordHall",
  "Brick_075_L_GeneralShale_GS_BradfordHall",
  "BrickExecutive_L_GeneralShale_GS_BradfordHall",
  "BrickKing_L_GeneralShale_GS_BradfordHall",
  "BrickModular_L_GeneralShale_GS_BradfordHall",
  "BrickQueen_L_GeneralShale_GS_BradfordHall",
  "Brick_03_L_GeneralShale_GS_Graymoor",
  "Brick_05_L_GeneralShale_GS_Graymoor",
  "Brick_075_L_GeneralShale_GS_Graymoor",
  "BrickExecutive_L_GeneralShale_GS_Graymoor",
  "BrickKing_L_GeneralShale_GS_Graymoor",
  "BrickModular_L_GeneralShale_GS_Graymoor",
  "BrickQueen_L_GeneralShale_GS_Graymoor",
  "Brick_03_L_Triangle_CapeFear",
  "Brick_05_L_Triangle_CapeFear",
  "Brick_075_L_Triangle_CapeFear",
  "BrickExecutive_L_Triangle_CapeFear",
  "BrickKing_L_Triangle_CapeFear",
  "BrickModular_L_Triangle_CapeFear",
  "BrickQueen_L_Triangle_CapeFear",
  "Brick_03_L_GeneralShale_GS_ClaytonFalls",
  "Brick_05_L_GeneralShale_GS_ClaytonFalls",
  "Brick_075_L_GeneralShale_GS_ClaytonFalls",
  "BrickExecutive_L_GeneralShale_GS_ClaytonFalls",
  "BrickKing_L_GeneralShale_GS_ClaytonFalls",
  "BrickModular_L_GeneralShale_GS_ClaytonFalls",
  "BrickQueen_L_GeneralShale_GS_ClaytonFalls",
  "Brick_03_L_GeneralShale_GS_RedColonial",
  "Brick_05_L_GeneralShale_GS_RedColonial",
  "Brick_075_L_GeneralShale_GS_RedColonial",
  "BrickExecutive_L_GeneralShale_GS_RedColonial",
  "BrickKing_L_GeneralShale_GS_RedColonial",
  "BrickModular_L_GeneralShale_GS_RedColonial",
  "BrickQueen_L_GeneralShale_GS_RedColonial",
  "Brick_03_L_Triangle_Nantucket",
  "Brick_05_L_Triangle_Nantucket",
  "Brick_075_L_Triangle_Nantucket",
  "BrickExecutive_L_Triangle_Nantucket",
  "BrickKing_L_Triangle_Nantucket",
  "BrickModular_L_Triangle_Nantucket",
  "BrickQueen_L_Triangle_Nantucket",
  "Brick_03_L_USBrick_OldJackson",
  "Brick_05_L_USBrick_OldJackson",
  "Brick_075_L_USBrick_OldJackson",
  "BrickExecutive_L_USBrick_OldJackson",
  "BrickKing_L_USBrick_OldJackson",
  "BrickModular_L_USBrick_OldJackson",
  "BrickQueen_L_USBrick_OldJackson",
  "Brick_03_L_GeneralShale_GS_Valor",
  "Brick_05_L_GeneralShale_GS_Valor",
  "Brick_075_L_GeneralShale_GS_Valor",
  "BrickExecutive_L_GeneralShale_GS_Valor",
  "BrickKing_L_GeneralShale_GS_Valor",
  "BrickModular_L_GeneralShale_GS_Valor",
  "BrickQueen_L_GeneralShale_GS_Valor",
  "Brick_03_L_Acme_AnsleyPark",
  "Brick_03_L_Acme_Menawa",
  "Brick_03_L_Acme_MushroomBrown",
  "Brick_03_L_Acme_Texas",
  "Brick_05_L_Acme_AnsleyPark",
  "Brick_05_L_Acme_Menawa",
  "Brick_05_L_Acme_MushroomBrown",
  "Brick_05_L_Acme_Texas",
  "Brick_075_L_Acme_AnsleyPark",
  "Brick_075_L_Acme_Menawa",
  "Brick_075_L_Acme_MushroomBrown",
  "Brick_075_L_Acme_Texas",
  "BrickExecutive_L_Acme_AnsleyPark",
  "BrickExecutive_L_Acme_Menawa",
  "BrickExecutive_L_Acme_MushroomBrown",
  "BrickExecutive_L_Acme_Texas",
  "BrickKing_L_Acme_AnsleyPark",
  "BrickKing_L_Acme_Menawa",
  "BrickKing_L_Acme_MushroomBrown",
  "BrickKing_L_Acme_Texas",
  "BrickModular_L_Acme_AnsleyPark",
  "BrickModular_L_Acme_Menawa",
  "BrickModular_L_Acme_MushroomBrown",
  "BrickModular_L_Acme_Texas",
  "BrickQueen_L_Acme_AnsleyPark",
  "BrickQueen_L_Acme_Menawa",
  "BrickQueen_L_Acme_MushroomBrown",
  "BrickQueen_L_Acme_Texas",
  "Brick_03_L_Triangle_FederalHill",
  "Brick_03_L_Triangle_Portsmouth",
  "Brick_03_L_Triangle_RiverStreet",
  "Brick_03_L_Triangle_Wilmington",
  "Brick_05_L_Triangle_FederalHill",
  "Brick_05_L_Triangle_Portsmouth",
  "Brick_05_L_Triangle_RiverStreet",
  "Brick_05_L_Triangle_Wilmington",
  "Brick_075_L_Triangle_FederalHill",
  "Brick_075_L_Triangle_Portsmouth",
  "Brick_075_L_Triangle_RiverStreet",
  "Brick_075_L_Triangle_Wilmington",
  "BrickExecutive_L_Triangle_FederalHill",
  "BrickExecutive_L_Triangle_Portsmouth",
  "BrickExecutive_L_Triangle_RiverStreet",
  "BrickExecutive_L_Triangle_Wilmington",
  "BrickKing_L_Triangle_FederalHill",
  "BrickKing_L_Triangle_Portsmouth",
  "BrickKing_L_Triangle_RiverStreet",
  "BrickKing_L_Triangle_Wilmington",
  "BrickModular_L_Triangle_FederalHill",
  "BrickModular_L_Triangle_Portsmouth",
  "BrickModular_L_Triangle_RiverStreet",
  "BrickModular_L_Triangle_Wilmington",
  "BrickQueen_L_Triangle_FederalHill",
  "BrickQueen_L_Triangle_Portsmouth",
  "BrickQueen_L_Triangle_RiverStreet",
  "BrickQueen_L_Triangle_Wilmington",
  "Brick_03_L_Triangle_ChesapeakeGrey",
  "Brick_05_L_Triangle_ChesapeakeGrey",
  "Brick_075_L_Triangle_ChesapeakeGrey",
  "BrickExecutive_L_Triangle_ChesapeakeGrey",
  "BrickKing_L_Triangle_ChesapeakeGrey",
  "BrickModular_L_Triangle_ChesapeakeGrey",
  "BrickQueen_L_Triangle_ChesapeakeGrey",
  "Brick_03_L_Acme_OldTavern",
  "Brick_05_L_Acme_OldTavern",
  "Brick_075_L_Acme_OldTavern",
  "BrickExecutive_L_Acme_OldTavern",
  "BrickKing_L_Acme_OldTavern",
  "BrickModular_L_Acme_OldTavern",
  "BrickQueen_L_Acme_OldTavern",
  "Brick_03_L_PVStone_Colonial",
  "Brick_03_L_PVStone_Neptune",
  "Brick_05_L_PVStone_Colonial",
  "Brick_05_L_PVStone_Neptune",
  "Brick_075_L_PVStone_Colonial",
  "Brick_075_L_PVStone_Neptune",
  "BrickExecutive_L_PVStone_Colonial",
  "BrickExecutive_L_PVStone_Neptune",
  "BrickKing_L_PVStone_Colonial",
  "BrickKing_L_PVStone_Neptune",
  "BrickModular_L_PVStone_Colonial",
  "BrickModular_L_PVStone_Neptune",
  "BrickQueen_L_PVStone_Colonial",
  "BrickQueen_L_PVStone_Neptune",
  "Brick_03_L_Binsa_EnglishDove",
  "Brick_03_L_Claymex_Aspen",
  "Brick_05_L_Binsa_EnglishDove",
  "Brick_05_L_Claymex_Aspen",
  "Brick_075_L_Binsa_EnglishDove",
  "Brick_075_L_Claymex_Aspen",
  "BrickExecutive_L_Binsa_EnglishDove",
  "BrickExecutive_L_Claymex_Aspen",
  "BrickKing_L_Binsa_EnglishDove",
  "BrickKing_L_Claymex_Aspen",
  "BrickModular_L_Binsa_EnglishDove",
  "BrickModular_L_Claymex_Aspen",
  "BrickQueen_L_Binsa_EnglishDove",
  "BrickQueen_L_Claymex_Aspen",
  "Brick_03_L_Triangle_Oakton",
  "Brick_03_L_USBrick_OldWaverly",
  "Brick_05_L_Triangle_Oakton",
  "Brick_05_L_USBrick_OldWaverly",
  "Brick_075_L_Triangle_Oakton",
  "Brick_075_L_USBrick_OldWaverly",
  "BrickExecutive_L_Triangle_Oakton",
  "BrickExecutive_L_USBrick_OldWaverly",
  "BrickKing_L_Triangle_Oakton",
  "BrickKing_L_USBrick_OldWaverly",
  "BrickModular_L_Triangle_Oakton",
  "BrickModular_L_USBrick_OldWaverly",
  "BrickQueen_L_Triangle_Oakton",
  "BrickQueen_L_USBrick_OldWaverly",
  "Brick_03_L_Cherokee_Magnolia",
  "Brick_05_L_Cherokee_Magnolia",
  "Brick_075_L_Cherokee_Magnolia",
  "BrickExecutive_L_Cherokee_Magnolia",
  "BrickKing_L_Cherokee_Magnolia",
  "BrickModular_L_Cherokee_Magnolia",
  "BrickQueen_L_Cherokee_Magnolia",
  "Brick_03_L_Acme_AdenBlend",
  "Brick_05_L_Acme_AdenBlend",
  "Brick_075_L_Acme_AdenBlend",
  "BrickExecutive_L_Acme_AdenBlend",
  "BrickKing_L_Acme_AdenBlend",
  "BrickModular_L_Acme_AdenBlend",
  "BrickQueen_L_Acme_AdenBlend",
  "Brick_03_L_Acme_Abbeville",
  "Brick_05_L_Acme_Abbeville",
  "Brick_075_L_Acme_Abbeville",
  "BrickExecutive_L_Acme_Abbeville",
  "BrickKing_L_Acme_Abbeville",
  "BrickModular_L_Acme_Abbeville",
  "BrickQueen_L_Acme_Abbeville",
  "Brick_03_L_PrestigeStone_PS_Farmhouse",
  "Brick_03_L_USBrick_Magnolia",
  "Brick_03_L_USBrick_NatchezTrace",
  "Brick_03_L_USBrick_OysterCove",
  "Brick_03_L_USBrick_ShadowStone",
  "Brick_03_L_USBrick_TimberWood",
  "Brick_05_L_PrestigeStone_PS_Farmhouse",
  "Brick_05_L_USBrick_Magnolia",
  "Brick_05_L_USBrick_NatchezTrace",
  "Brick_05_L_USBrick_OysterCove",
  "Brick_05_L_USBrick_ShadowStone",
  "Brick_05_L_USBrick_TimberWood",
  "Brick_075_L_PrestigeStone_PS_Farmhouse",
  "Brick_075_L_USBrick_Magnolia",
  "Brick_075_L_USBrick_NatchezTrace",
  "Brick_075_L_USBrick_OysterCove",
  "Brick_075_L_USBrick_ShadowStone",
  "Brick_075_L_USBrick_TimberWood",
  "BrickExecutive_L_PrestigeStone_PS_Farmhouse",
  "BrickExecutive_L_USBrick_Magnolia",
  "BrickExecutive_L_USBrick_NatchezTrace",
  "BrickExecutive_L_USBrick_OysterCove",
  "BrickExecutive_L_USBrick_ShadowStone",
  "BrickExecutive_L_USBrick_TimberWood",
  "BrickKing_L_PrestigeStone_PS_Farmhouse",
  "BrickKing_L_USBrick_Magnolia",
  "BrickKing_L_USBrick_NatchezTrace",
  "BrickKing_L_USBrick_OysterCove",
  "BrickKing_L_USBrick_ShadowStone",
  "BrickKing_L_USBrick_TimberWood",
  "BrickModular_L_PrestigeStone_PS_Farmhouse",
  "BrickModular_L_USBrick_Magnolia",
  "BrickModular_L_USBrick_NatchezTrace",
  "BrickModular_L_USBrick_OysterCove",
  "BrickModular_L_USBrick_ShadowStone",
  "BrickModular_L_USBrick_TimberWood",
  "BrickQueen_L_PrestigeStone_PS_Farmhouse",
  "BrickQueen_L_USBrick_Magnolia",
  "BrickQueen_L_USBrick_NatchezTrace",
  "BrickQueen_L_USBrick_OysterCove",
  "BrickQueen_L_USBrick_ShadowStone",
  "BrickQueen_L_USBrick_TimberWood",
  "Brick_03_L_Acme_AuburnHills",
  "Brick_05_L_Acme_AuburnHills",
  "Brick_075_L_Acme_AuburnHills",
  "BrickExecutive_L_Acme_AuburnHills",
  "BrickKing_L_Acme_AuburnHills",
  "BrickModular_L_Acme_AuburnHills",
  "BrickQueen_L_Acme_AuburnHills",
  "Brick_03_L_Acme_Saltgrass",
  "Brick_03_L_Acme_SummerSage",
  "Brick_03_L_CommercialBrickCompany_CBC_ChandlerWhite",
  "Brick_03_L_CommercialBrickCompany_CBC_Hollister",
  "Brick_03_L_RedRiver_FlintRanch",
  "Brick_03_L_RedRiver_OzarkSmoke",
  "Brick_05_L_Acme_Saltgrass",
  "Brick_05_L_Acme_SummerSage",
  "Brick_05_L_CommercialBrickCompany_CBC_ChandlerWhite",
  "Brick_05_L_CommercialBrickCompany_CBC_Hollister",
  "Brick_05_L_RedRiver_FlintRanch",
  "Brick_05_L_RedRiver_OzarkSmoke",
  "Brick_075_L_Acme_Saltgrass",
  "Brick_075_L_Acme_SummerSage",
  "Brick_075_L_CommercialBrickCompany_CBC_ChandlerWhite",
  "Brick_075_L_CommercialBrickCompany_CBC_Hollister",
  "Brick_075_L_RedRiver_FlintRanch",
  "Brick_075_L_RedRiver_OzarkSmoke",
  "BrickExecutive_L_Acme_Saltgrass",
  "BrickExecutive_L_Acme_SummerSage",
  "BrickExecutive_L_CommercialBrickCompany_CBC_ChandlerWhite",
  "BrickExecutive_L_CommercialBrickCompany_CBC_Hollister",
  "BrickExecutive_L_RedRiver_FlintRanch",
  "BrickExecutive_L_RedRiver_OzarkSmoke",
  "BrickKing_L_Acme_Saltgrass",
  "BrickKing_L_Acme_SummerSage",
  "BrickKing_L_CommercialBrickCompany_CBC_ChandlerWhite",
  "BrickKing_L_CommercialBrickCompany_CBC_Hollister",
  "BrickKing_L_RedRiver_FlintRanch",
  "BrickKing_L_RedRiver_OzarkSmoke",
  "BrickModular_L_Acme_Saltgrass",
  "BrickModular_L_Acme_SummerSage",
  "BrickModular_L_CommercialBrickCompany_CBC_ChandlerWhite",
  "BrickModular_L_CommercialBrickCompany_CBC_Hollister",
  "BrickModular_L_RedRiver_FlintRanch",
  "BrickModular_L_RedRiver_OzarkSmoke",
  "BrickQueen_L_Acme_Saltgrass",
  "BrickQueen_L_Acme_SummerSage",
  "BrickQueen_L_CommercialBrickCompany_CBC_ChandlerWhite",
  "BrickQueen_L_CommercialBrickCompany_CBC_Hollister",
  "BrickQueen_L_RedRiver_FlintRanch",
  "BrickQueen_L_RedRiver_OzarkSmoke",
  "Brick_03_L_Acme_Shenandoah",
  "Brick_03_L_Acme_SpanishBay",
  "Brick_03_L_Acme_WhiteBluff",
  "Brick_03_L_Ryder_AntiqueWhite",
  "Brick_03_L_Ryder_Casablanca",
  "Brick_05_L_Acme_Shenandoah",
  "Brick_05_L_Acme_SpanishBay",
  "Brick_05_L_Acme_WhiteBluff",
  "Brick_05_L_Ryder_AntiqueWhite",
  "Brick_05_L_Ryder_Casablanca",
  "Brick_075_L_Acme_Shenandoah",
  "Brick_075_L_Acme_SpanishBay",
  "Brick_075_L_Acme_WhiteBluff",
  "Brick_075_L_Ryder_AntiqueWhite",
  "Brick_075_L_Ryder_Casablanca",
  "BrickExecutive_L_Acme_Shenandoah",
  "BrickExecutive_L_Acme_SpanishBay",
  "BrickExecutive_L_Acme_WhiteBluff",
  "BrickExecutive_L_Ryder_AntiqueWhite",
  "BrickExecutive_L_Ryder_Casablanca",
  "BrickKing_L_Acme_Shenandoah",
  "BrickKing_L_Acme_SpanishBay",
  "BrickKing_L_Acme_WhiteBluff",
  "BrickKing_L_Ryder_AntiqueWhite",
  "BrickKing_L_Ryder_Casablanca",
  "BrickModular_L_Acme_Shenandoah",
  "BrickModular_L_Acme_SpanishBay",
  "BrickModular_L_Acme_WhiteBluff",
  "BrickModular_L_Ryder_AntiqueWhite",
  "BrickModular_L_Ryder_Casablanca",
  "BrickQueen_L_Acme_Shenandoah",
  "BrickQueen_L_Acme_SpanishBay",
  "BrickQueen_L_Acme_WhiteBluff",
  "BrickQueen_L_Ryder_AntiqueWhite",
  "BrickQueen_L_Ryder_Casablanca",
  "Brick_03_L_Acme_ArcticMist",
  "Brick_03_L_Acme_Inverness",
  "Brick_05_L_Acme_ArcticMist",
  "Brick_05_L_Acme_Inverness",
  "Brick_075_L_Acme_ArcticMist",
  "Brick_075_L_Acme_Inverness",
  "BrickExecutive_L_Acme_ArcticMist",
  "BrickExecutive_L_Acme_Inverness",
  "BrickKing_L_Acme_ArcticMist",
  "BrickKing_L_Acme_Inverness",
  "BrickModular_L_Acme_ArcticMist",
  "BrickModular_L_Acme_Inverness",
  "BrickQueen_L_Acme_ArcticMist",
  "BrickQueen_L_Acme_Inverness",
  "Brick_03_L_TexasStone_DarkGrayLuxbrick",
  "Brick_03_L_TexasStone_OldTownLux",
  "Brick_05_L_TexasStone_DarkGrayLuxbrick",
  "Brick_05_L_TexasStone_OldTownLux",
  "Brick_075_L_TexasStone_DarkGrayLuxbrick",
  "Brick_075_L_TexasStone_OldTownLux",
  "BrickExecutive_L_TexasStone_DarkGrayLuxbrick",
  "BrickExecutive_L_TexasStone_OldTownLux",
  "BrickKing_L_TexasStone_DarkGrayLuxbrick",
  "BrickKing_L_TexasStone_OldTownLux",
  "BrickModular_L_TexasStone_DarkGrayLuxbrick",
  "BrickModular_L_TexasStone_OldTownLux",
  "BrickQueen_L_TexasStone_DarkGrayLuxbrick",
  "BrickQueen_L_TexasStone_OldTownLux",
  "Brick_03_L_Acme_GlacierWhite",
  "Brick_03_L_Belden_BlackDiamondVelour",
  "Brick_03_L_Belden_GraphiteVelour",
  "Brick_03_L_Spaulding_YankeeHill",
  "Brick_05_L_Acme_GlacierWhite",
  "Brick_05_L_Belden_BlackDiamondVelour",
  "Brick_05_L_Belden_GraphiteVelour",
  "Brick_05_L_Spaulding_YankeeHill",
  "Brick_075_L_Acme_GlacierWhite",
  "Brick_075_L_Belden_BlackDiamondVelour",
  "Brick_075_L_Belden_GraphiteVelour",
  "Brick_075_L_Spaulding_YankeeHill",
  "BrickExecutive_L_Acme_GlacierWhite",
  "BrickExecutive_L_Belden_BlackDiamondVelour",
  "BrickExecutive_L_Belden_GraphiteVelour",
  "BrickExecutive_L_Spaulding_YankeeHill",
  "BrickKing_L_Acme_GlacierWhite",
  "BrickKing_L_Belden_BlackDiamondVelour",
  "BrickKing_L_Belden_GraphiteVelour",
  "BrickKing_L_Spaulding_YankeeHill",
  "BrickModular_L_Acme_GlacierWhite",
  "BrickModular_L_Belden_BlackDiamondVelour",
  "BrickModular_L_Belden_GraphiteVelour",
  "BrickModular_L_Spaulding_YankeeHill",
  "BrickQueen_L_Acme_GlacierWhite",
  "BrickQueen_L_Belden_BlackDiamondVelour",
  "BrickQueen_L_Belden_GraphiteVelour",
  "BrickQueen_L_Spaulding_YankeeHill",
  "Brick_03_L_GeneralShale_GS_Graysburg",
  "Brick_03_L_GeneralShale_GS_MorningSmoke",
  "Brick_03_L_GeneralShale_GS_OldEnglishTutor",
  "Brick_05_L_GeneralShale_GS_Graysburg",
  "Brick_05_L_GeneralShale_GS_MorningSmoke",
  "Brick_05_L_GeneralShale_GS_OldEnglishTutor",
  "Brick_075_L_GeneralShale_GS_Graysburg",
  "Brick_075_L_GeneralShale_GS_MorningSmoke",
  "Brick_075_L_GeneralShale_GS_OldEnglishTutor",
  "BrickExecutive_L_GeneralShale_GS_Graysburg",
  "BrickExecutive_L_GeneralShale_GS_MorningSmoke",
  "BrickExecutive_L_GeneralShale_GS_OldEnglishTutor",
  "BrickKing_L_GeneralShale_GS_Graysburg",
  "BrickKing_L_GeneralShale_GS_MorningSmoke",
  "BrickKing_L_GeneralShale_GS_OldEnglishTutor",
  "BrickModular_L_GeneralShale_GS_Graysburg",
  "BrickModular_L_GeneralShale_GS_MorningSmoke",
  "BrickModular_L_GeneralShale_GS_OldEnglishTutor",
  "BrickQueen_L_GeneralShale_GS_Graysburg",
  "BrickQueen_L_GeneralShale_GS_MorningSmoke",
  "BrickQueen_L_GeneralShale_GS_OldEnglishTutor",
  "Brick_03_L_GeneralShale_GS_ModenaPaver",
  "Brick_05_L_GeneralShale_GS_ModenaPaver",
  "Brick_075_L_GeneralShale_GS_ModenaPaver",
  "BrickExecutive_L_GeneralShale_GS_ModenaPaver",
  "BrickKing_L_GeneralShale_GS_ModenaPaver",
  "BrickModular_L_GeneralShale_GS_ModenaPaver",
  "BrickQueen_L_GeneralShale_GS_ModenaPaver",
  "Brick_03_L_GeneralShale_GS_Winterhaven",
  "Brick_03_L_USBrick_Alamo",
  "Brick_03_L_USBrick_AspenChase",
  "Brick_03_L_USBrick_Belhaven",
  "Brick_03_L_USBrick_BelleMeade",
  "Brick_03_L_USBrick_MtRushmore",
  "Brick_03_L_USBrick_Newcastle",
  "Brick_03_L_USBrick_NorthHighland",
  "Brick_03_L_USBrick_OldOverton",
  "Brick_03_L_USBrick_StLorain",
  "Brick_05_L_GeneralShale_GS_Winterhaven",
  "Brick_05_L_USBrick_Alamo",
  "Brick_05_L_USBrick_AspenChase",
  "Brick_05_L_USBrick_Belhaven",
  "Brick_05_L_USBrick_BelleMeade",
  "Brick_05_L_USBrick_MtRushmore",
  "Brick_05_L_USBrick_Newcastle",
  "Brick_05_L_USBrick_NorthHighland",
  "Brick_05_L_USBrick_OldOverton",
  "Brick_05_L_USBrick_StLorain",
  "Brick_075_L_GeneralShale_GS_Winterhaven",
  "Brick_075_L_USBrick_Alamo",
  "Brick_075_L_USBrick_AspenChase",
  "Brick_075_L_USBrick_Belhaven",
  "Brick_075_L_USBrick_BelleMeade",
  "Brick_075_L_USBrick_MtRushmore",
  "Brick_075_L_USBrick_Newcastle",
  "Brick_075_L_USBrick_NorthHighland",
  "Brick_075_L_USBrick_OldOverton",
  "Brick_075_L_USBrick_StLorain",
  "BrickExecutive_L_GeneralShale_GS_Winterhaven",
  "BrickExecutive_L_USBrick_Alamo",
  "BrickExecutive_L_USBrick_AspenChase",
  "BrickExecutive_L_USBrick_Belhaven",
  "BrickExecutive_L_USBrick_BelleMeade",
  "BrickExecutive_L_USBrick_MtRushmore",
  "BrickExecutive_L_USBrick_Newcastle",
  "BrickExecutive_L_USBrick_NorthHighland",
  "BrickExecutive_L_USBrick_OldOverton",
  "BrickExecutive_L_USBrick_StLorain",
  "BrickKing_L_GeneralShale_GS_Winterhaven",
  "BrickKing_L_USBrick_Alamo",
  "BrickKing_L_USBrick_AspenChase",
  "BrickKing_L_USBrick_Belhaven",
  "BrickKing_L_USBrick_BelleMeade",
  "BrickKing_L_USBrick_MtRushmore",
  "BrickKing_L_USBrick_Newcastle",
  "BrickKing_L_USBrick_NorthHighland",
  "BrickKing_L_USBrick_OldOverton",
  "BrickKing_L_USBrick_StLorain",
  "BrickModular_L_GeneralShale_GS_Winterhaven",
  "BrickModular_L_USBrick_Alamo",
  "BrickModular_L_USBrick_AspenChase",
  "BrickModular_L_USBrick_Belhaven",
  "BrickModular_L_USBrick_BelleMeade",
  "BrickModular_L_USBrick_MtRushmore",
  "BrickModular_L_USBrick_Newcastle",
  "BrickModular_L_USBrick_NorthHighland",
  "BrickModular_L_USBrick_OldOverton",
  "BrickModular_L_USBrick_StLorain",
  "BrickQueen_L_GeneralShale_GS_Winterhaven",
  "BrickQueen_L_USBrick_Alamo",
  "BrickQueen_L_USBrick_AspenChase",
  "BrickQueen_L_USBrick_Belhaven",
  "BrickQueen_L_USBrick_BelleMeade",
  "BrickQueen_L_USBrick_MtRushmore",
  "BrickQueen_L_USBrick_Newcastle",
  "BrickQueen_L_USBrick_NorthHighland",
  "BrickQueen_L_USBrick_OldOverton",
  "BrickQueen_L_USBrick_StLorain",
  "Brick_03_L_Harristone_Midnight",
  "Brick_03_L_HenryBrick_HB_Avondale",
  "Brick_03_L_Spaulding_Onslow",
  "Brick_05_L_Harristone_Midnight",
  "Brick_05_L_HenryBrick_HB_Avondale",
  "Brick_05_L_Spaulding_Onslow",
  "Brick_075_L_Harristone_Midnight",
  "Brick_075_L_HenryBrick_HB_Avondale",
  "Brick_075_L_Spaulding_Onslow",
  "BrickExecutive_L_Harristone_Midnight",
  "BrickExecutive_L_HenryBrick_HB_Avondale",
  "BrickExecutive_L_Spaulding_Onslow",
  "BrickKing_L_Harristone_Midnight",
  "BrickKing_L_HenryBrick_HB_Avondale",
  "BrickKing_L_Spaulding_Onslow",
  "BrickModular_L_Harristone_Midnight",
  "BrickModular_L_HenryBrick_HB_Avondale",
  "BrickModular_L_Spaulding_Onslow",
  "BrickQueen_L_Harristone_Midnight",
  "BrickQueen_L_HenryBrick_HB_Avondale",
  "BrickQueen_L_Spaulding_Onslow",
  "Brick_03_L_Columbus_MagnoliaBay",
  "Brick_03_L_Columbus_Weracoba2",
  "Brick_05_L_Columbus_MagnoliaBay",
  "Brick_05_L_Columbus_Weracoba2",
  "Brick_075_L_Columbus_MagnoliaBay",
  "Brick_075_L_Columbus_Weracoba2",
  "BrickExecutive_L_Columbus_MagnoliaBay",
  "BrickExecutive_L_Columbus_Weracoba2",
  "BrickKing_L_Columbus_MagnoliaBay",
  "BrickKing_L_Columbus_Weracoba2",
  "BrickModular_L_Columbus_MagnoliaBay",
  "BrickModular_L_Columbus_Weracoba2",
  "BrickQueen_L_Columbus_MagnoliaBay",
  "BrickQueen_L_Columbus_Weracoba2",
  "Brick_03_L_Binsa_Monroe",
  "Brick_03_L_Binsa_Smokey",
  "Brick_03_L_Meridian_FireOak",
  "Brick_03_L_Meridian_WhiteHillstone",
  "Brick_03_L_Meridian_WhiteRiverRock",
  "Brick_05_L_Binsa_Monroe",
  "Brick_05_L_Binsa_Smokey",
  "Brick_05_L_Meridian_FireOak",
  "Brick_05_L_Meridian_WhiteHillstone",
  "Brick_05_L_Meridian_WhiteRiverRock",
  "Brick_075_L_Binsa_Monroe",
  "Brick_075_L_Binsa_Smokey",
  "Brick_075_L_Meridian_FireOak",
  "Brick_075_L_Meridian_WhiteHillstone",
  "Brick_075_L_Meridian_WhiteRiverRock",
  "BrickExecutive_L_Binsa_Monroe",
  "BrickExecutive_L_Binsa_Smokey",
  "BrickExecutive_L_Meridian_FireOak",
  "BrickExecutive_L_Meridian_WhiteHillstone",
  "BrickExecutive_L_Meridian_WhiteRiverRock",
  "BrickKing_L_Binsa_Monroe",
  "BrickKing_L_Binsa_Smokey",
  "BrickKing_L_Meridian_FireOak",
  "BrickKing_L_Meridian_WhiteHillstone",
  "BrickKing_L_Meridian_WhiteRiverRock",
  "BrickModular_L_Binsa_Monroe",
  "BrickModular_L_Binsa_Smokey",
  "BrickModular_L_Meridian_FireOak",
  "BrickModular_L_Meridian_WhiteHillstone",
  "BrickModular_L_Meridian_WhiteRiverRock",
  "BrickQueen_L_Binsa_Monroe",
  "BrickQueen_L_Binsa_Smokey",
  "BrickQueen_L_Meridian_FireOak",
  "BrickQueen_L_Meridian_WhiteHillstone",
  "BrickQueen_L_Meridian_WhiteRiverRock",
  "Brick_03_L_USBrick_Twilight",
  "Brick_05_L_USBrick_Twilight",
  "Brick_075_L_USBrick_Twilight",
  "BrickExecutive_L_USBrick_Twilight",
  "BrickKing_L_USBrick_Twilight",
  "BrickModular_L_USBrick_Twilight",
  "BrickQueen_L_USBrick_Twilight",
  "Brick_03_L_Triangle_ShadowRidge",
  "Brick_05_L_Triangle_ShadowRidge",
  "Brick_075_L_Triangle_ShadowRidge",
  "BrickExecutive_L_Triangle_ShadowRidge",
  "BrickKing_L_Triangle_ShadowRidge",
  "BrickModular_L_Triangle_ShadowRidge",
  "BrickQueen_L_Triangle_ShadowRidge",
  "Brick_03_L_GeneralShale_GS_EnglishPub",
  "Brick_03_L_GeneralShale_GS_Ironworks",
  "Brick_03_L_GeneralShale_GS_Peppermill",
  "Brick_03_L_GlenGery_Americano",
  "Brick_03_L_GlenGery_AnthraciteSmooth",
  "Brick_03_L_GlenGery_AspenWhite",
  "Brick_03_L_GlenGery_BaxterBrownSmooth",
  "Brick_03_L_GlenGery_ClassicCreamSmooth",
  "Brick_03_L_GlenGery_RusticGrayWaterstruck",
  "Brick_05_L_GeneralShale_GS_EnglishPub",
  "Brick_05_L_GeneralShale_GS_Ironworks",
  "Brick_05_L_GeneralShale_GS_Peppermill",
  "Brick_05_L_GlenGery_Americano",
  "Brick_05_L_GlenGery_AnthraciteSmooth",
  "Brick_05_L_GlenGery_AspenWhite",
  "Brick_05_L_GlenGery_BaxterBrownSmooth",
  "Brick_05_L_GlenGery_ClassicCreamSmooth",
  "Brick_05_L_GlenGery_RusticGrayWaterstruck",
  "Brick_075_L_GeneralShale_GS_EnglishPub",
  "Brick_075_L_GeneralShale_GS_Ironworks",
  "Brick_075_L_GeneralShale_GS_Peppermill",
  "Brick_075_L_GlenGery_Americano",
  "Brick_075_L_GlenGery_AnthraciteSmooth",
  "Brick_075_L_GlenGery_AspenWhite",
  "Brick_075_L_GlenGery_BaxterBrownSmooth",
  "Brick_075_L_GlenGery_ClassicCreamSmooth",
  "Brick_075_L_GlenGery_RusticGrayWaterstruck",
  "BrickExecutive_L_GeneralShale_GS_EnglishPub",
  "BrickExecutive_L_GeneralShale_GS_Ironworks",
  "BrickExecutive_L_GeneralShale_GS_Peppermill",
  "BrickExecutive_L_GlenGery_Americano",
  "BrickExecutive_L_GlenGery_AnthraciteSmooth",
  "BrickExecutive_L_GlenGery_AspenWhite",
  "BrickExecutive_L_GlenGery_BaxterBrownSmooth",
  "BrickExecutive_L_GlenGery_ClassicCreamSmooth",
  "BrickExecutive_L_GlenGery_RusticGrayWaterstruck",
  "BrickKing_L_GeneralShale_GS_EnglishPub",
  "BrickKing_L_GeneralShale_GS_Ironworks",
  "BrickKing_L_GeneralShale_GS_Peppermill",
  "BrickKing_L_GlenGery_Americano",
  "BrickKing_L_GlenGery_AnthraciteSmooth",
  "BrickKing_L_GlenGery_AspenWhite",
  "BrickKing_L_GlenGery_BaxterBrownSmooth",
  "BrickKing_L_GlenGery_ClassicCreamSmooth",
  "BrickKing_L_GlenGery_RusticGrayWaterstruck",
  "BrickModular_L_GeneralShale_GS_EnglishPub",
  "BrickModular_L_GeneralShale_GS_Ironworks",
  "BrickModular_L_GeneralShale_GS_Peppermill",
  "BrickModular_L_GlenGery_Americano",
  "BrickModular_L_GlenGery_AnthraciteSmooth",
  "BrickModular_L_GlenGery_AspenWhite",
  "BrickModular_L_GlenGery_BaxterBrownSmooth",
  "BrickModular_L_GlenGery_ClassicCreamSmooth",
  "BrickModular_L_GlenGery_RusticGrayWaterstruck",
  "BrickQueen_L_GeneralShale_GS_EnglishPub",
  "BrickQueen_L_GeneralShale_GS_Ironworks",
  "BrickQueen_L_GeneralShale_GS_Peppermill",
  "BrickQueen_L_GlenGery_Americano",
  "BrickQueen_L_GlenGery_AnthraciteSmooth",
  "BrickQueen_L_GlenGery_AspenWhite",
  "BrickQueen_L_GlenGery_BaxterBrownSmooth",
  "BrickQueen_L_GlenGery_ClassicCreamSmooth",
  "BrickQueen_L_GlenGery_RusticGrayWaterstruck",
  "Brick_03_L_GeneralShale_GS_ColonyPointe",
  "Brick_03_L_GeneralShale_GS_CumberlandTudor",
  "Brick_05_L_GeneralShale_GS_ColonyPointe",
  "Brick_05_L_GeneralShale_GS_CumberlandTudor",
  "Brick_075_L_GeneralShale_GS_ColonyPointe",
  "Brick_075_L_GeneralShale_GS_CumberlandTudor",
  "BrickExecutive_L_GeneralShale_GS_ColonyPointe",
  "BrickExecutive_L_GeneralShale_GS_CumberlandTudor",
  "BrickKing_L_GeneralShale_GS_ColonyPointe",
  "BrickKing_L_GeneralShale_GS_CumberlandTudor",
  "BrickModular_L_GeneralShale_GS_ColonyPointe",
  "BrickModular_L_GeneralShale_GS_CumberlandTudor",
  "BrickQueen_L_GeneralShale_GS_ColonyPointe",
  "BrickQueen_L_GeneralShale_GS_CumberlandTudor",
  "Brick_03_L_Acme_StoneLake",
  "Brick_03_L_RedRiver_Madrono",
  "Brick_03_L_USBrick_WeatheredWhite",
  "Brick_05_L_Acme_StoneLake",
  "Brick_05_L_RedRiver_Madrono",
  "Brick_05_L_USBrick_WeatheredWhite",
  "Brick_075_L_Acme_StoneLake",
  "Brick_075_L_RedRiver_Madrono",
  "Brick_075_L_USBrick_WeatheredWhite",
  "BrickExecutive_L_Acme_StoneLake",
  "BrickExecutive_L_RedRiver_Madrono",
  "BrickExecutive_L_USBrick_WeatheredWhite",
  "BrickKing_L_Acme_StoneLake",
  "BrickKing_L_RedRiver_Madrono",
  "BrickKing_L_USBrick_WeatheredWhite",
  "BrickModular_L_Acme_StoneLake",
  "BrickModular_L_RedRiver_Madrono",
  "BrickModular_L_USBrick_WeatheredWhite",
  "BrickQueen_L_Acme_StoneLake",
  "BrickQueen_L_RedRiver_Madrono",
  "BrickQueen_L_USBrick_WeatheredWhite",
  "Brick_03_L_Acme_Redmont",
  "Brick_03_L_Acme_SpanishFort",
  "Brick_03_L_Columbus_Charleston",
  "Brick_03_L_Columbus_Georgetown",
  "Brick_03_L_Columbus_OldBailey",
  "Brick_03_L_Columbus_Ortega",
  "Brick_03_L_Columbus_StoneChase",
  "Brick_03_L_Triangle_KnobHill",
  "Brick_03_L_USBrick_Laredo",
  "Brick_05_L_Acme_Redmont",
  "Brick_05_L_Acme_SpanishFort",
  "Brick_05_L_Columbus_Charleston",
  "Brick_05_L_Columbus_Georgetown",
  "Brick_05_L_Columbus_OldBailey",
  "Brick_05_L_Columbus_Ortega",
  "Brick_05_L_Columbus_StoneChase",
  "Brick_05_L_Triangle_KnobHill",
  "Brick_05_L_USBrick_Laredo",
  "Brick_075_L_Acme_Redmont",
  "Brick_075_L_Acme_SpanishFort",
  "Brick_075_L_Columbus_Charleston",
  "Brick_075_L_Columbus_Georgetown",
  "Brick_075_L_Columbus_OldBailey",
  "Brick_075_L_Columbus_Ortega",
  "Brick_075_L_Columbus_StoneChase",
  "Brick_075_L_Triangle_KnobHill",
  "Brick_075_L_USBrick_Laredo",
  "BrickExecutive_L_Acme_Redmont",
  "BrickExecutive_L_Acme_SpanishFort",
  "BrickExecutive_L_Columbus_Charleston",
  "BrickExecutive_L_Columbus_Georgetown",
  "BrickExecutive_L_Columbus_OldBailey",
  "BrickExecutive_L_Columbus_Ortega",
  "BrickExecutive_L_Columbus_StoneChase",
  "BrickExecutive_L_Triangle_KnobHill",
  "BrickExecutive_L_USBrick_Laredo",
  "BrickKing_L_Acme_Redmont",
  "BrickKing_L_Acme_SpanishFort",
  "BrickKing_L_Columbus_Charleston",
  "BrickKing_L_Columbus_Georgetown",
  "BrickKing_L_Columbus_OldBailey",
  "BrickKing_L_Columbus_Ortega",
  "BrickKing_L_Columbus_StoneChase",
  "BrickKing_L_Triangle_KnobHill",
  "BrickKing_L_USBrick_Laredo",
  "BrickModular_L_Acme_Redmont",
  "BrickModular_L_Acme_SpanishFort",
  "BrickModular_L_Columbus_Charleston",
  "BrickModular_L_Columbus_Georgetown",
  "BrickModular_L_Columbus_OldBailey",
  "BrickModular_L_Columbus_Ortega",
  "BrickModular_L_Columbus_StoneChase",
  "BrickModular_L_Triangle_KnobHill",
  "BrickModular_L_USBrick_Laredo",
  "BrickQueen_L_Acme_Redmont",
  "BrickQueen_L_Acme_SpanishFort",
  "BrickQueen_L_Columbus_Charleston",
  "BrickQueen_L_Columbus_Georgetown",
  "BrickQueen_L_Columbus_OldBailey",
  "BrickQueen_L_Columbus_Ortega",
  "BrickQueen_L_Columbus_StoneChase",
  "BrickQueen_L_Triangle_KnobHill",
  "BrickQueen_L_USBrick_Laredo",
  "Brick_03_L_Acme_CiboloTrail",
  "Brick_03_L_Acme_CopperasCove",
  "Brick_03_L_Acme_OxfordPlace",
  "Brick_03_L_Claymex_UrbanaAntique",
  "Brick_03_L_CommercialBrickCompany_CBC_CommercialAntique",
  "Brick_03_L_Master_Chateau",
  "Brick_03_L_Master_PortEdwards",
  "Brick_03_L_RedRiver_SteelManor",
  "Brick_03_L_RedRiver_SummerAsh",
  "Brick_05_L_Acme_CiboloTrail",
  "Brick_05_L_Acme_CopperasCove",
  "Brick_05_L_Acme_OxfordPlace",
  "Brick_05_L_Claymex_UrbanaAntique",
  "Brick_05_L_CommercialBrickCompany_CBC_CommercialAntique",
  "Brick_05_L_Master_Chateau",
  "Brick_05_L_Master_PortEdwards",
  "Brick_05_L_RedRiver_SteelManor",
  "Brick_05_L_RedRiver_SummerAsh",
  "Brick_075_L_Acme_CiboloTrail",
  "Brick_075_L_Acme_CopperasCove",
  "Brick_075_L_Acme_OxfordPlace",
  "Brick_075_L_Claymex_UrbanaAntique",
  "Brick_075_L_CommercialBrickCompany_CBC_CommercialAntique",
  "Brick_075_L_Master_Chateau",
  "Brick_075_L_Master_PortEdwards",
  "Brick_075_L_RedRiver_SteelManor",
  "Brick_075_L_RedRiver_SummerAsh",
  "BrickExecutive_L_Acme_CiboloTrail",
  "BrickExecutive_L_Acme_CopperasCove",
  "BrickExecutive_L_Acme_OxfordPlace",
  "BrickExecutive_L_Claymex_UrbanaAntique",
  "BrickExecutive_L_CommercialBrickCompany_CBC_CommercialAntique",
  "BrickExecutive_L_Master_Chateau",
  "BrickExecutive_L_Master_PortEdwards",
  "BrickExecutive_L_RedRiver_SteelManor",
  "BrickExecutive_L_RedRiver_SummerAsh",
  "BrickKing_L_Acme_CiboloTrail",
  "BrickKing_L_Acme_CopperasCove",
  "BrickKing_L_Acme_OxfordPlace",
  "BrickKing_L_Claymex_UrbanaAntique",
  "BrickKing_L_CommercialBrickCompany_CBC_CommercialAntique",
  "BrickKing_L_Master_Chateau",
  "BrickKing_L_Master_PortEdwards",
  "BrickKing_L_RedRiver_SteelManor",
  "BrickKing_L_RedRiver_SummerAsh",
  "BrickModular_L_Acme_CiboloTrail",
  "BrickModular_L_Acme_CopperasCove",
  "BrickModular_L_Acme_OxfordPlace",
  "BrickModular_L_Claymex_UrbanaAntique",
  "BrickModular_L_CommercialBrickCompany_CBC_CommercialAntique",
  "BrickModular_L_Master_Chateau",
  "BrickModular_L_Master_PortEdwards",
  "BrickModular_L_RedRiver_SteelManor",
  "BrickModular_L_RedRiver_SummerAsh",
  "BrickQueen_L_Acme_CiboloTrail",
  "BrickQueen_L_Acme_CopperasCove",
  "BrickQueen_L_Acme_OxfordPlace",
  "BrickQueen_L_Claymex_UrbanaAntique",
  "BrickQueen_L_CommercialBrickCompany_CBC_CommercialAntique",
  "BrickQueen_L_Master_Chateau",
  "BrickQueen_L_Master_PortEdwards",
  "BrickQueen_L_RedRiver_SteelManor",
  "BrickQueen_L_RedRiver_SummerAsh",
  "Brick_03_L_Acme_WhiteBirch",
  "Brick_05_L_Acme_WhiteBirch",
  "Brick_075_L_Acme_WhiteBirch",
  "BrickExecutive_L_Acme_WhiteBirch",
  "BrickKing_L_Acme_WhiteBirch",
  "BrickModular_L_Acme_WhiteBirch",
  "BrickQueen_L_Acme_WhiteBirch",
];
